/**
 * Created by mqamhieh on 2/27/17.
 */
import {useWorkingPatternsWarningsFactory} from "../../../hmodules/working-patterns/factories/working-patterns-warnings.factory.js";

(function () {

    var scheduleDataServiceV2;
    var scheduleCostsServiceV2;
    var tsUsersService;
    var MinorSchedulingService;
    var WorkRestrictionsService;
    var WorkVisasService;
    var FairSchedulingService;
    var JustCauseService;
    var PhilippinesMinWeeklyHoursService;
    var _filter;
    var _scheduleDateUtilsService;
    let workingPatternsWarningsFactory;

    var ScheduleWarningServiceV2 = function () {
        var self = this;
        self.sortBy;
        self.viewType;
        self.emitter = JarEventEmitter.call(this);

        self.WARNINGS_SEVERITY = {
            LOW: 'LOW',
            MEDIUM: 'MEDIUM',
            HIGH: 'HIGH',
        }

        self.WARNINGS_SEVERITY_DETAILS = {
            [self.WARNINGS_SEVERITY.LOW]: {
                label: $filter("translate")("low"),
                description: $filter("translate")("This won't block publishing but might need attention"),
                order: 3
            },
            [self.WARNINGS_SEVERITY.MEDIUM]: {
                label: $filter("translate")("medium"),
                description: $filter("translate")("I strongly recommend fixing these"),
                order: 2
            },
            [self.WARNINGS_SEVERITY.HIGH]: {
                label: $filter("translate")("critical"),
                description: $filter("translate")("These must be fixed before publishing"),
                order: 1
            },
        };

        self.WARNING_LEVELS = {
            SHIFT_LEVEL: 'SHIFT_LEVEL',
            EMPLOYEE_LEVEL: 'EMPLOYEE_LEVEL',
            SCHEDULE_LEVEL: 'SCHEDULE_LEVEL',
        };

        self.WARNING_CATEGORIES = {
            CONTRACTED_HOURS_SHIFTS: {
                code: 'CONTRACTED_HOURS_SHIFTS',
                name: ['UK', 'DK'].indexOf(scheduleDataServiceV2.teamLiveCountryCode) > -1 ? $filter('translate')('Outside contract') : $filter('translate')('Outside max weekly hours'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.LOW
            },
            UNSCHEDULED_BREAKS: {
                code: 'UNSCHEDULED_BREAKS',
                name: $filter('translate')('Unscheduled breaks'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.LOW
            },
            CALENDAR_DAY_OF_REST: {
                code: 'CALENDAR_DAY_OF_REST',
                name: $filter('translate')('Day of rest breach'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            BUSINESS_DAY_OF_REST: {
                code: 'BUSINESS_DAY_OF_REST',
                name: $filter('translate')('Day of rest breach'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            MINORS: {
                code: 'MINORS',
                name: $filter('translate')('Minors breach'),
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            WORK_VISA: {
                code: 'WORK_VISA',
                name: $filter('translate')('Work visa breach'),
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            WORK_LIMIT: {
                code: 'WORK_LIMIT',
                name: $filter('translate')('48hr work limit'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            SPLIT_SHIFT_PREMIUMS: {
                code: 'SPLIT_SHIFT_PREMIUMS',
                name: $filter('translate')('Split shift'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            OVERTIME: {
                code: 'OVERTIME',
                name: $filter('translate')('Overtime'),
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            SEVENTH_CONSECUTIVE_OVERTIME: {
                code: 'SEVENTH_CONSECUTIVE_OVERTIME',
                name: $filter('translate')('7th consecutive day'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            CALL_INS: {
                code: 'CALL_INS',
                name: $filter('translate')('Reporting Time'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            FWW_PREMIUMS: {
                code: 'FWW_PREMIUMS',
                name: $filter('translate')('FWW Premiums'),
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            OVERLAP: {
                code: 'OVERLAP',
                name: $filter('translate')('Overlapping shifts'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            UNASSIGNED: {
                code: 'UNASSIGNED',
                name: $filter('translate')('Unassigned shifts'),
                warningLevel: self.WARNING_LEVELS.SCHEDULE_LEVEL,
                severity: self.WARNINGS_SEVERITY.LOW
            },
            OVERLAPPING_WITH: {
                code: 'OVERLAPPING_WITH',
                name: $filter('translate')('Overlapping with'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            GFE: {
                code: 'GFE',
                name: $filter('translate')('Good Faith Estimate') + ' (GFE)',
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            NYC_REGULAR_SCHEDULE: {
                code: 'NYC_REGULAR_SCHEDULE',
                name: $filter('translate')('Regular Schedule'),
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            SPREAD_OF_HOURS: {
                code: 'SPREAD_OF_HOURS',
                name: $filter('translate')('Spread of hours'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            DEACTIVATED: {
                code: 'DEACTIVATED',
                name: $filter('translate')('Cannot schedule'),
                description: $filter('translate')('Cannot schedule as these employees are either shared or deactivated') + '.',
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            EMPTY_DAYS: {
                code: 'EMPTY_DAYS',
                name: $filter('translate')('Unscheduled Days'),
                warningLevel: self.WARNING_LEVELS.SCHEDULE_LEVEL,
                severity: self.WARNINGS_SEVERITY.LOW
            },
            LIMIT_EXCEEDED_APPROVAL: {
                code: 'LIMIT_EXCEEDED_APPROVAL',
                name: $filter('translate')('Labor percentage limit'),
                description: $filter('translate')('Make sure the schedule doesn’t exceed the allowed labor percentage limit of') + ' ',
                warningLevel: self.WARNING_LEVELS.SCHEDULE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            TPCH_VIOLATIONS: {
                code: 'TPCH_VIOLATIONS',
                name: $filter('translate')('Minimum TPCH target'),
                description: $filter('translate')('Make sure to meet the TPCH target of') + ' ',
                warningLevel: self.WARNING_LEVELS.SCHEDULE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            HAS_JOB_TITLE_SCHEDULE_SKILL_LEVELS_WARNING: {
                code: 'HAS_JOB_TITLE_SCHEDULE_SKILL_LEVELS_WARNING',
                name: $filter('translate')('Station'),
                severity: self.WARNINGS_SEVERITY.LOW
            },
            RIGHT_TO_REST: {
                code: 'RIGHT_TO_REST',
                name: $filter('translate')('Right to rest') + ' (' + $filter('translate')('Clopening') + ')',
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            NO_SALES_APPROVAL: {
                code: 'NO_SALES_APPROVAL',
                name: $filter('translate')('No Sales Approval'),
                description: $filter('translate')('No Sales Approval'),
                warningLevel: self.WARNING_LEVELS.SCHEDULE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            UNDEFINED_AVAILABILITY: {
                code: 'UNDEFINED_AVAILABILITY',
                name: $filter('translate')('Undefined availability'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.LOW
            },
            INSUFFICIENT_PERMISSIONS_APPROVAL: {
                code: 'INSUFFICIENT_PERMISSIONS_APPROVAL',
                name: $filter('translate')('Insufficient permissions approval'),
                warningLevel: self.WARNING_LEVELS.SCHEDULE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            REST_BETWEEN_DAYS: {
                code: 'REST_BETWEEN_DAYS',
                name: $filter('translate')('Rest between working days'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            BELOW_MIN_WEEKLY_HOURS: {
                code: 'BELOW_MIN_WEEKLY_HOURS',
                name: $filter('translate')('Min scheduled hours breach'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            MARKED_DAY: {
                code: 'MARKED_DAY',
                name: $filter('translate')('Marked day'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            WORKING_PATTERN: {
                code: 'WORKING_PATTERN',
                name: $filter('translate')('Working pattern'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
            },
        };

        self.WARNING_SUB_CATEGORIES = {
            OVER_HOURS_PER_WEEK: {
                code: 'OVER_HOURS_PER_WEEK',
                name: $filter('translate')('Over hours per week'),
                parent: self.WARNING_CATEGORIES.WORKING_PATTERN,
                description: $filter('translate')('Reduce the number of hours per week the employee is scheduled for.'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
            },
            OVER_DAYS_PER_WEEK: {
                code: 'OVER_DAYS_PER_WEEK',
                name: $filter('translate')('Over days per week'),
                parent: self.WARNING_CATEGORIES.WORKING_PATTERN,
                description: $filter('translate')('Reduce the number of days per week the employee is scheduled for.'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
            },
            OVER_DAYS_AND_HOURS_PER_WEEK: {
                code: 'OVER_DAYS_AND_HOURS_PER_WEEK',
                name: $filter('translate')('Over days and hours per week'),
                parent: self.WARNING_CATEGORIES.WORKING_PATTERN,
                description: $filter('translate')('Reduce the number of hours and days per week the employee is scheduled for.'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
            },
            BELOW_HOURS_PER_WEEK: {
                code: 'BELOW_HOURS_PER_WEEK',
                name: $filter('translate')('Below hours per week'),
                parent: self.WARNING_CATEGORIES.WORKING_PATTERN,
                description: $filter('translate')('Increase the number of hours per week the employee is scheduled for.'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
            },
            BELOW_DAYS_PER_WEEK: {
                code: 'BELOW_DAYS_PER_WEEK',
                name: $filter('translate')('Below days per week'),
                parent: self.WARNING_CATEGORIES.WORKING_PATTERN,
                description: $filter('translate')('Increase the number of days per week the employee is scheduled for.'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
            },
            BELOW_DAYS_AND_HOURS_PER_WEEK: {
                code: 'BELOW_DAYS_AND_HOURS_PER_WEEK',
                name: $filter('translate')('Below days and hours per week'),
                parent: self.WARNING_CATEGORIES.WORKING_PATTERN,
                description: $filter('translate')('Increase the number of hours and days per week the employee is scheduled for.'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
            },
            SCHEDULED_ON_WRONG_DAY: {
                code: 'SCHEDULED_ON_WRONG_DAY',
                name: $filter('translate')('Scheduled on wrong day'),
                parent: self.WARNING_CATEGORIES.WORKING_PATTERN,
                description: $filter('translate')('Remove the shifts from the employee which are not part of their working pattern.'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
            },
            WRONG_HOURS_FOR_DAY: {
                code: 'WRONG_HOURS_FOR_DAY',
                name: $filter('translate')('Wrong hours for day'),
                parent: self.WARNING_CATEGORIES.WORKING_PATTERN,
                description: $filter('translate')('Reduce the hours for the employee on the days which are part of their working pattern.'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
            },
            OVER_CONTRACTED_HOURS: {
                code: 'OVER_CONTRACTED_HOURS',
                name: ['UK', 'DK'].indexOf(scheduleDataServiceV2.teamLiveCountryCode) > -1 ? $filter('translate')('Over the contracted hours') : $filter('translate')('Over the max weekly hours'),
                parent: self.WARNING_CATEGORIES.CONTRACTED_HOURS_SHIFTS,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.LOW
            },
            OVER_CONTRACTED_SHIFTS: {
                code: 'OVER_CONTRACTED_SHIFTS',
                name: $filter('translate')('Over the contracted shifts'),
                parent: self.WARNING_CATEGORIES.CONTRACTED_HOURS_SHIFTS,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.LOW
            },
            BELOW_CONTRACTED_HOURS: {
                code: 'BELOW_CONTRACTED_HOURS',
                name: $filter('translate')('Below the contracted hours'),
                parent: self.WARNING_CATEGORIES.CONTRACTED_HOURS_SHIFTS,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.LOW
            },
            BELOW_CONTRACTED_SHIFTS: {
                code: 'BELOW_CONTRACTED_SHIFTS',
                name: $filter('translate')('Below the contracted shifts'),
                parent: self.WARNING_CATEGORIES.CONTRACTED_HOURS_SHIFTS,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.LOW
            },
            IN_SCHOOL_TIME: {
                code: 'IN_SCHOOL_TIME',
                name: $filter('translate')('Overlap with school times'),
                parent: self.WARNING_CATEGORIES.MINORS,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            MAX_GUEST_WEEKLY_HOURS: {
                code: 'MAX_GUEST_WEEKLY_HOURS',
                name: $filter('translate')('Guest employee overtime'),
                parent: self.WARNING_CATEGORIES.OVERTIME,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            WEEKLY_OVERTIME: {
                code: 'WEEKLY_OVERTIME',
                name: $filter('translate')('Weekly overtime'),
                parent: self.WARNING_CATEGORIES.OVERTIME,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            DAILY_OVERTIME: {
                code: 'DAILY_OVERTIME',
                name: $filter('translate')('Daily overtime'),
                parent: self.WARNING_CATEGORIES.OVERTIME,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            DAILY_DOUBLE_OVERTIME: {
                code: 'DAILY_DOUBLE_OVERTIME',
                name: $filter('translate')('Double overtime'),
                parent: self.WARNING_CATEGORIES.OVERTIME,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            CONSECUTIVE_DOUBLE_OVERTIME: {
                code: 'CONSECUTIVE_DOUBLE_OVERTIME',
                name: $filter('translate')('Consecutive Double overtime'),
                parent: self.WARNING_CATEGORIES.OVERTIME,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            CONSECUTIVE_OVERTIME: {
                code: 'CONSECUTIVE_OVERTIME',
                name: $filter('translate')('Consecutive overtime'),
                parent: self.WARNING_CATEGORIES.OVERTIME,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            PH_REST_DAY_OVERTIME: {
                code: 'PH_REST_DAY_OVERTIME',
                name: $filter('translate')('Rest day premium'),
                parent: self.WARNING_CATEGORIES.OVERTIME,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            DATE_TIME_CHANGE: {
                code: 'DATE_TIME_CHANGE',
                name: $filter('translate')('Change time'),
                parent: self.WARNING_CATEGORIES.FWW_PREMIUMS,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            LENGTH_INCREMENT: {
                code: 'LENGTH_INCREMENT',
                name: $filter('translate')('Adding hours'),
                parent: self.WARNING_CATEGORIES.FWW_PREMIUMS,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            LENGTH_DECREMENT: {
                code: 'LENGTH_DECREMENT',
                name: $filter('translate')('Subtracting hours'),
                parent: self.WARNING_CATEGORIES.FWW_PREMIUMS,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            PENDING_EMPLOYEE_CONSENT: {
                code: 'PENDING_EMPLOYEE_CONSENT',
                name: $filter('translate')('Pending employee’s consent'),
                parent: self.WARNING_CATEGORIES.FWW_PREMIUMS,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            NEW_HIRED_EMPLOYEE: {
                code: 'NEW_HIRED_EMPLOYEE',
                name: $filter('translate')('Newly hired employees'),
                parent: self.WARNING_CATEGORIES.FWW_PREMIUMS,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                description: $filter('translate')('There are no premiums to pay for newly hired employees first week in a published schedule') + '.',
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            AVAILABILITY: {
                code: 'AVAILABILITY',
                name: $filter('translate')('Availability'),
                parent: self.WARNING_CATEGORIES.OVERLAPPING_WITH,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            TIME_OFF: {
                code: 'TIME_OFF',
                name: $filter('translate')('Time off'),
                parent: self.WARNING_CATEGORIES.OVERLAPPING_WITH,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            ABSENCE: {
                code: 'ABSENCE',
                name: $filter('translate')('Absence'),
                parent: self.WARNING_CATEGORIES.OVERLAPPING_WITH,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            SICKNESS: {
                code: 'SICKNESS',
                name: $filter('translate')('Sickness'),
                parent: self.WARNING_CATEGORIES.OVERLAPPING_WITH,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            HOLIDAY: {
                code: 'HOLIDAY',
                name: $filter('translate')('Holiday'),
                parent: self.WARNING_CATEGORIES.OVERLAPPING_WITH,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            NO_EFFECTIVE_GFE: {
                code: 'NO_EFFECTIVE_GFE',
                name: $filter('translate')('GFE required'),
                parent: self.WARNING_CATEGORIES.GFE,
                description: $filter('translate')('Make sure the employee has up to date GFE'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            NOT_SCHEDULED: {
                code: 'NOT_SCHEDULED',
                name: $filter('translate')('Missing schedule'),
                parent: self.WARNING_CATEGORIES.GFE,
                description: $filter('translate')('Make sure you schedule the employee to the GFE requirements'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            WORKING_DAYS: {
                code: 'WORKING_DAYS',
                name: $filter('translate')('Working days breach'),
                parent: self.WARNING_CATEGORIES.GFE,
                description: $filter('translate')('The working days are different to those in the GFE'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            WORKING_LOCATION: {
                code: 'WORKING_LOCATION',
                name: $filter('translate')('Scheduled location breach'),
                parent: self.WARNING_CATEGORIES.GFE,
                description: $filter('translate')('The scheduled locations are different to those in the GFE'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            WORKING_HOURS_WINDOW: {
                code: 'WORKING_HOURS_WINDOW',
                name: $filter('translate')('Shift times breach'),
                parent: self.WARNING_CATEGORIES.GFE,
                description: $filter('translate')('The employees scheduled start and end times are different to those in the GFE'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            HAS_SIGNIFICANT_CHANGE: {
                code: 'HAS_SIGNIFICANT_CHANGE',
                name: $filter('translate')('GFE significant change'),
                parent: self.WARNING_CATEGORIES.GFE,
                description: $filter('translate')('Make sure the employee has up to date GFE'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            TOTAL_HOURS: {
                code: 'TOTAL_HOURS',
                name: $filter('translate')('Total hours breach'),
                parent: self.WARNING_CATEGORIES.GFE,
                description: $filter('translate')('Total scheduled hours are different to those in the GFE'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            NO_EFFECTIVE_REGULAR_SCHEDULE: {
                code: 'NO_EFFECTIVE_REGULAR_SCHEDULE',
                name: $filter('translate')('Regular Schedule required'),
                parent: self.WARNING_CATEGORIES.NYC_REGULAR_SCHEDULE,
                description: $filter('translate')('Make sure the employee has up to date Regular Schedule'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            HAS_PENDING_REGULAR_SCHEDULE: {
                code: 'HAS_PENDING_REGULAR_SCHEDULE',
                name: $filter('translate')('Pending acknowledgment'),
                parent: self.WARNING_CATEGORIES.NYC_REGULAR_SCHEDULE,
                description: $filter('translate')('Make sure the employee E-signs and acknowledges their regular schedule'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.LOW
            },
            NYC_NOT_SCHEDULED: {
                code: 'NYC_NOT_SCHEDULED',
                name: $filter('translate')('Missing schedule'),
                parent: self.WARNING_CATEGORIES.NYC_REGULAR_SCHEDULE,
                description: $filter('translate')('Make sure you schedule the employee to the Regular Schedule requirements'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            NYC_WORKING_DAYS: {
                code: 'NYC_WORKING_DAYS',
                name: $filter('translate')('Working days breach'),
                parent: self.WARNING_CATEGORIES.NYC_REGULAR_SCHEDULE,
                description: $filter('translate')('The working days are different to those in the Regular Schedule'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            NYC_WORKING_LOCATION: {
                code: 'NYC_WORKING_LOCATION',
                name: $filter('translate')('Scheduled location breach'),
                parent: self.WARNING_CATEGORIES.NYC_REGULAR_SCHEDULE,
                description: $filter('translate')('The scheduled locations are different to those in the Regular Schedule'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            NYC_WORKING_HOURS_WINDOW: {
                code: 'NYC_WORKING_HOURS_WINDOW',
                name: $filter('translate')('Shift times breach'),
                parent: self.WARNING_CATEGORIES.NYC_REGULAR_SCHEDULE,
                description: $filter('translate')('The employees scheduled start and end times are different to those in the Regular Schedule'),
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            NYC_HAS_SIGNIFICANT_CHANGE: {
                code: 'NYC_HAS_SIGNIFICANT_CHANGE',
                name: $filter('translate')('Regular Schedule significant change'),
                parent: self.WARNING_CATEGORIES.NYC_REGULAR_SCHEDULE,
                description: $filter('translate')('Make sure the employee has up to date Regular Schedule'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            REGULAR_SCHEDULE_VARIATION: {
                code: 'REGULAR_SCHEDULE_VARIATION',
                name: $filter('translate')('Over')+' 15% '+$filter('translate')('variations'),
                parent: self.WARNING_CATEGORIES.NYC_REGULAR_SCHEDULE,
                description: $filter('translate')('Total scheduled hours are different to those in the Regular Schedule by more than')+' 15%. '
                    + $filter('translate')('The employee requested changes do not count towards the Regular Schedule variations'),
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            PROHIBITED_HOURS: {
                code: 'PROHIBITED_HOURS',
                name: $filter('translate')('Outside permitted hours'),
                parent: self.WARNING_CATEGORIES.MINORS,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                description: $filter('translate')('Make sure you schedule in the permitted working hours'),
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            BEFORE_VISA_START_DATE: {
                code: 'BEFORE_VISA_START_DATE',
                name: $filter('translate')('Before visa start date'),
                parent: self.WARNING_CATEGORIES.WORK_VISA,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            AFTER_VISA_END_DATE: {
                code: 'AFTER_VISA_END_DATE',
                name: $filter('translate')('After visa end date'),
                parent: self.WARNING_CATEGORIES.WORK_VISA,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            MINOR_EMPLOYEE_EXCEEDS_HOURS_PER_WEEK: {
                code: 'MINOR_EMPLOYEE_EXCEEDS_HOURS_PER_WEEK',
                name: $filter('translate')('Over allowed weekly hours'),
                parent: self.WARNING_CATEGORIES.MINORS,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            MINOR_NO_EFFECTIVE_WORK_PERMIT: {
                code: 'MINOR_NO_EFFECTIVE_WORK_PERMIT',
                name: $filter('translate')('No active minor work permit'),
                parent: self.WARNING_CATEGORIES.MINORS,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            WORK_VISA_EMPLOYEE_EXCEEDS_HOURS_PER_WEEK: {
                code: 'WORK_VISA_EMPLOYEE_EXCEEDS_HOURS_PER_WEEK',
                name: $filter('translate')('Over max hours per week'),
                parent: self.WARNING_CATEGORIES.WORK_VISA,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            MINOR_ROLLING_24_HOURS: {
                code: 'MINOR_ROLLING_24_HOURS',
                name: $filter('translate')(''),
                parent: self.WARNING_CATEGORIES.MINORS,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                description: $filter('translate')(''),
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            MINOR_EMPLOYEE_EXCEEDS_DAYS_PER_WEEK: {
                code: 'MINOR_EMPLOYEE_EXCEEDS_DAYS_PER_WEEK',
                name: $filter('translate')('Over days per week'),
                parent: self.WARNING_CATEGORIES.MINORS,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            WORK_VISA_EMPLOYEE_EXCEEDS_DAYS_PER_WEEK: {
                code: 'WORK_VISA_EMPLOYEE_EXCEEDS_DAYS_PER_WEEK',
                name: $filter('translate')('Over max days per week'),
                parent: self.WARNING_CATEGORIES.WORK_VISA,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            MINOR_EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR: {
                code: 'MINOR_EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR',
                name: $filter('translate')('No school calendar assigned'),
                parent: self.WARNING_CATEGORIES.MINORS,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            WORK_VISA_EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR: {
                code: 'WORK_VISA_EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR',
                name: $filter('translate')('No school calendar assigned'),
                parent: self.WARNING_CATEGORIES.WORK_VISA,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            NO_EFFECTIVE_MINOR_TYPE: {
                code: 'NO_EFFECTIVE_MINOR_TYPE',
                name: $filter('translate')('No minor type assigned'),
                parent: self.WARNING_CATEGORIES.MINORS,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            MAX_WEEKLY_HOURS: {
                code: 'MAX_WEEKLY_HOURS',
                name: $filter('translate')('Over hours per week'),
                parent: self.WARNING_CATEGORIES.MINORS,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.LOW
            },
            MINOR_MAX_HOURS_PER_DAY: {
                code: 'MINOR_MAX_HOURS_PER_DAY',
                name: $filter('translate')('Over hours per day'),
                parent: self.WARNING_CATEGORIES.MINORS,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            MINOR_MAX_COMBINED_HOURS_PER_DAY: {
                code: 'MINOR_MAX_COMBINED_HOURS_PER_DAY',
                name: $filter('translate')('Over combined hours per day'),
                parent: self.WARNING_CATEGORIES.MINORS,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            UNDEFINED_JOB_TITLE_LEVEL: {
                code: 'UNDEFINED_JOB_TITLE_LEVEL',
                name: $filter('translate')('Skill level not assigned'),
                parent: self.WARNING_CATEGORIES.HAS_JOB_TITLE_SCHEDULE_SKILL_LEVELS_WARNING,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.LOW
            },
            SKILL_LEVEL_4_OR_5: {
                code: 'SKILL_LEVEL_4_OR_5',
                name: $filter('translate')('Skill level set to 4 or 5'),
                parent: self.WARNING_CATEGORIES.HAS_JOB_TITLE_SCHEDULE_SKILL_LEVELS_WARNING,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.LOW
            },
            FIRST_HALF_OF_CALENDAR_DAY_OF_REST: {
                code: 'FIRST_HALF_OF_CALENDAR_DAY_OF_REST',
                name: $filter('translate')(''),
                parent: self.WARNING_CATEGORIES.CALENDAR_DAY_OF_REST,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            SECOND_HALF_OF_CALENDAR_DAY_OF_REST: {
                code: 'SECOND_HALF_OF_CALENDAR_DAY_OF_REST',
                name: $filter('translate')(''),
                parent: self.WARNING_CATEGORIES.CALENDAR_DAY_OF_REST,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.MEDIUM
            },
            OVER_WORK_LIMIT: {
                code: 'OVER_WORK_LIMIT',
                name: $filter('translate')('Over 48hr work limit'),
                parent: self.WARNING_CATEGORIES.WORK_LIMIT,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_PER_WEEK: {
                code: 'MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_PER_WEEK',
                name: $filter('translate')('Below rest hours per week'),
                parent: self.WARNING_CATEGORIES.MINORS,
                warningLevel: self.WARNING_LEVELS.EMPLOYEE_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
            MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_BETWEEN_SHIFTS: {
                code: 'MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_BETWEEN_SHIFTS',
                name: $filter('translate')('Below rest hours between shifts'),
                parent: self.WARNING_CATEGORIES.MINORS,
                warningLevel: self.WARNING_LEVELS.SHIFT_LEVEL,
                severity: self.WARNINGS_SEVERITY.HIGH
            },
        };

        var penaltiesWarnings;
        var gfeWarnings;
        var restBetweenDaysWarnings;

        var OVERTIME_RATE_MAP = {
            1.25: '1.25x',
            1.5: '1.5x',
            1.69: '1.69x',
            2.6: '2.6x',
            1.95: '1.95x',
            3.38: '3.38x',
        };

        self.checkIfWarningEnabled = function (code) {
            const scheduleWarningsConfiguration = scheduleDataServiceV2.scheduleWarningsConfiguration;
            const isWorkingPatternsServiceEnabled = scheduleDataServiceV2.getIsWorkingPatternEnabled();
            let warningCode = code;
            if (['STATUTORY_HOLIDAY', 'COMPANY_HOLIDAY'].indexOf(code) > -1) {
                warningCode = self.WARNING_SUB_CATEGORIES.HOLIDAY.code;
            } else if (['UNAUTHORIZED', 'CUSTOM', 'ADOPTION', 'SHARED_PARENTAL', 'MATERNITY', 'BEREAVEMENT', 'PATERNITY', 'SHARED_PARENTAL_ADOPTION'].indexOf(code) > -1) {
                warningCode = self.WARNING_SUB_CATEGORIES.ABSENCE.code;
            }

            switch (warningCode) {
                case self.WARNING_SUB_CATEGORIES.AVAILABILITY.code:
                    return scheduleWarningsConfiguration.show_availability_overlap_warning;
                case self.WARNING_SUB_CATEGORIES.TIME_OFF.code:
                    return scheduleWarningsConfiguration.show_time_off_overlap_warning;
                case self.WARNING_SUB_CATEGORIES.SICKNESS.code:
                    return scheduleWarningsConfiguration.show_sickness_overlap_warning;
                case self.WARNING_SUB_CATEGORIES.HOLIDAY.code:
                    return scheduleWarningsConfiguration.show_holiday_overlap_warning;
                case self.WARNING_SUB_CATEGORIES.ABSENCE.code:
                    return scheduleWarningsConfiguration.show_absence_overlap_warning;
                case self.WARNING_CATEGORIES.UNDEFINED_AVAILABILITY.code:
                    return scheduleWarningsConfiguration.show_undefined_availability_warning;
                case self.WARNING_SUB_CATEGORIES.UNDEFINED_JOB_TITLE_LEVEL.code:
                    return scheduleWarningsConfiguration.show_job_title_skill_level_not_assigned_warning;
                case self.WARNING_SUB_CATEGORIES.SKILL_LEVEL_4_OR_5.code:
                    return scheduleWarningsConfiguration.show_skill_level_exceeding_threshold_warning === 3;
                case self.WARNING_SUB_CATEGORIES.BELOW_CONTRACTED_SHIFTS.code:
                    return scheduleWarningsConfiguration.show_below_contracted_shifts_warning;
                case self.WARNING_SUB_CATEGORIES.OVER_CONTRACTED_SHIFTS.code:
                    return scheduleWarningsConfiguration.show_over_contracted_shifts_warning;
                case self.WARNING_SUB_CATEGORIES.BELOW_CONTRACTED_HOURS.code:
                    return !isWorkingPatternsServiceEnabled && scheduleWarningsConfiguration.show_below_contracted_hours_warning;
                case self.WARNING_SUB_CATEGORIES.OVER_CONTRACTED_HOURS.code:
                    if (isWorkingPatternsServiceEnabled) {
                        return false;
                    }
                    return ['UK', 'DK'].indexOf(scheduleDataServiceV2.teamLiveCountryCode) > -1 ? scheduleWarningsConfiguration.show_over_contracted_hours_warning : scheduleWarningsConfiguration.show_over_max_weekly_hours_warning;
                case self.WARNING_SUB_CATEGORIES.OVER_DAYS_AND_HOURS_PER_WEEK.code:
                    return isWorkingPatternsServiceEnabled && scheduleWarningsConfiguration.show_over_working_pattern_warning;
                case self.WARNING_SUB_CATEGORIES.BELOW_DAYS_AND_HOURS_PER_WEEK.code:
                    return isWorkingPatternsServiceEnabled && scheduleWarningsConfiguration.show_below_working_pattern_warning;
                case self.WARNING_SUB_CATEGORIES.SCHEDULED_ON_WRONG_DAY.code:
                    return isWorkingPatternsServiceEnabled && scheduleWarningsConfiguration.show_working_pattern_variations_warning;
                case self.WARNING_CATEGORIES.UNASSIGNED.code:
                    return scheduleWarningsConfiguration.show_unassigned_shifts_warning;
                case self.WARNING_CATEGORIES.EMPTY_DAYS.code:
                    return scheduleWarningsConfiguration.show_unscheduled_days_warning;
                case self.WARNING_CATEGORIES.UNSCHEDULED_BREAKS.code:
                    return scheduleWarningsConfiguration.show_unscheduled_breaks_warning;
                default:
                    return true;
            }
        };

        var doOverlap = function (shift1, shift2) {
            var shift1Start = _scheduleDateUtilsService.moment(shift1.start_time).valueOf();
            var shift2Start = _scheduleDateUtilsService.moment(shift2.start_time).valueOf();
            var shift1End = _scheduleDateUtilsService.moment(shift1.end_time).valueOf();
            var shift2End = _scheduleDateUtilsService.moment(shift2.end_time).valueOf();

            if (
                (shift1Start < shift2Start && shift1End <= shift2Start) ||
                (shift1End > shift2End && shift1Start >= shift2End)
            ) {
                return false;
            }

            return true;
        };

        var getGFEWarningsTypeList = function (type) {
            var warningsCodes = [];

            if (type === 'ROW') {
                warningsCodes = [
                    'HAS_SIGNIFICANT_CHANGE',
                    'NO_EFFECTIVE_GFE',
                    'TOTAL_HOURS',
                    'NYC_HAS_SIGNIFICANT_CHANGE',
                    'NO_EFFECTIVE_REGULAR_SCHEDULE',
                    'HAS_PENDING_REGULAR_SCHEDULE',
                    'REGULAR_SCHEDULE_VARIATION'
                ];
            } else if (type === 'SHIFT') {
                warningsCodes = [
                    'WORKING_LOCATION',
                    'WORKING_HOURS_WINDOW',
                    'WORKING_DAYS',
                    'NYC_WORKING_LOCATION',
                    'NYC_WORKING_HOURS_WINDOW',
                    'NYC_WORKING_DAYS'
                ];
            }

            return warningsCodes;
        };

        var prepareGFEWarningText = function (gfeWarning) {
            var message;
            var activeScheduleView = scheduleDataServiceV2.getActiveScheduleViewType();
            var activeScheduleDay = activeScheduleView && activeScheduleView.id === 'DAILY' ? scheduleDataServiceV2.getActiveScheduleDay() : scheduleDataServiceV2.startDate;

            switch (gfeWarning.code) {
                case 'HAS_SIGNIFICANT_CHANGE':
                    message = 'GFE significant change. Make sure they have up to date GFE';
                    break;

                case 'TOTAL_HOURS':
                    message = 'Total scheduled hours is ' + Math.abs(gfeWarning.totalHoursPercentage) + '% ';

                    if (gfeWarning.totalHoursPercentage > 0) {
                        message += 'more than the GFE hours';
                    } else {
                        message += 'less than the GFE hours';
                    }

                    break;

                case 'NO_EFFECTIVE_GFE':
                    if (gfeWarning.nonCoveredDays && gfeWarning.nonCoveredDays.length) {
                        if (activeScheduleView && activeScheduleView.id === 'WEEKLY') {
                            if (gfeWarning.nonCoveredDays.length === 1) {
                                message = [moment(gfeWarning.nonCoveredDays[0]).format("dddd"), $filter('translate')('is not covered by a GFE') + '.'].join(' ');
                            } else {
                                message = [moment(gfeWarning.nonCoveredDays[0]).format("dddd"), '-', moment(gfeWarning.nonCoveredDays[gfeWarning.nonCoveredDays.length - 1]).format("dddd"), $filter('translate')('are not covered by a GFE') + '.'].join(' ');
                            }
                        } else {
                            message = [moment(activeScheduleDay).format("dddd"), $filter('translate')('is not covered by a GFE') + '.'].join(' ');
                        }
                    } else {
                        message = $filter('translate')('GFE required') + '. ' + $filter('translate')('Make sure they have up to date GFE');
                    }
                    break;

                case 'WORKING_DAYS':
                    message = 'GFE. Working day are different to those in the GFE';

                    break;

                 case 'WORKING_LOCATION':
                    message = 'GFE. Scheduled locations are different to those in the GFE';

                    break;
                case 'WORKING_HOURS_WINDOW':
                    message = 'GFE. Scheduled hours differ by at least 1 hour from their GFE';

                    break;
                case 'NYC_HAS_SIGNIFICANT_CHANGE':
                    message = 'Regular Schedule significant change. Make sure they have up to date Regular Schedule';
                    break;

                case 'REGULAR_SCHEDULE_VARIATION':
                    message = 'Regular Schedule. Scheduled hours differ by more than 15% from their Regular Schedule';

                    break;

                case 'HAS_PENDING_REGULAR_SCHEDULE':
                    message = 'Regular schedule unacknowledged. Make sure they E-sign and acknowledge their regular schedule ';
                    var effectiveDate = moment(gfeWarning.documentDetails.effective_start_date).format('MMM DD, YYYY');

                    if (gfeWarning.documentDetails.status === 'SCHEDULED') {
                        message += 'will take effect on ';
                    }
                    else if (gfeWarning.documentDetails.status === 'ACTIVE') {
                        message += 'which is effective from ';
                    }
                    message += effectiveDate;
                    break;

                case 'NO_EFFECTIVE_REGULAR_SCHEDULE':
                    if (gfeWarning.nonCoveredDays && gfeWarning.nonCoveredDays.length) {
                        if (activeScheduleView && activeScheduleView.id === 'WEEKLY') {
                            if (gfeWarning.nonCoveredDays.length === 1) {
                                message = [moment(gfeWarning.nonCoveredDays[0]).format("dddd"), $filter('translate')('is not covered by a Regular Schedule') + '.'].join(' ');
                            } else {
                                message = [moment(gfeWarning.nonCoveredDays[0]).format("dddd"), '-', moment(gfeWarning.nonCoveredDays[gfeWarning.nonCoveredDays.length - 1]).format("dddd"), $filter('translate')('are not covered by a Regular Schedule') + '.'].join(' ');
                            }
                        } else {
                            message = [moment(activeScheduleDay).format("dddd"), $filter('translate')('is not covered by a Regular Schedule') + '.'].join(' ');
                        }
                    } else {
                        message = $filter('translate')('Regular Schedule required') + '. ' + $filter('translate')('Make sure they have up to date Regular Schedule');
                    }
                    break;

                case 'NYC_WORKING_DAYS':
                    message = 'Regular Schedule. Working day are different to those in the Regular Schedule';

                    break;

                 case 'NYC_WORKING_LOCATION':
                    message = 'Regular Schedule. Scheduled locations are different to those in the Regular Schedule';

                    break;
                case 'NYC_WORKING_HOURS_WINDOW':
                    message = 'Regular Schedule. Scheduled time differ by';

                    if (gfeWarning.difference < 3600) {
                        message += ' ' + (gfeWarning.difference / 60) + ' mins ';
                    } else {
                        var hours  =  _filter('number')( ((gfeWarning.difference - (gfeWarning.difference % 3600)) / 3600), 0);
                        var mins = (gfeWarning.difference % 3600) / 60;

                        message += ' ' + hours + ' hrs ';

                        if (mins > 0) {
                            message += 'and ' + mins + ' mins ';
                        }

                    }

                    message += 'from their Regular Schedule';

                    break;
            }

            return message;
        };

        var getWorkRestrictionWarningMsg = function (warning, day, isRestricted) {
            var message;
            switch (warning.key) {
                case warning.restrictionType + '_EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR':
                    message = (warning.restrictionType === 'MINOR' ? 'Minor' : 'Work Visa') + '.';

                    if (isRestricted) {
                        message += ' Assign them a school calendar';
                    } else {
                        message +=' No school calender';
                    }
                    message += (self.viewType === 'WEEKLY'? ' for ' + day: '');

                    break;
                case 'MINOR_NO_EFFECTIVE_WORK_PERMIT':
                    if (isRestricted) {
                        message = $filter('translate')('Minor. Assign them a minor work permit');
                    } else {
                        message = $filter('translate')('No active minor work permit was assigned on');
                        message += ` ${warning.from_date} - ${warning.to_date}.`;
                    }

                    break;

                case 'NO_EFFECTIVE_MINOR_TYPE':
                    if (isRestricted) {
                        message = 'Minor. Assign them a minor type';
                    } else {
                        message = 'Minor. No minor type';
                    }
                    message += (self.viewType === 'WEEKLY' ? ' for ' + day : '');

                    break;

                case warning.restrictionType + '_' +'EMPLOYEE_EXCEEDS_DAYS_PER_WEEK':
                    message = (warning.restrictionType === 'MINOR' ? 'Minor' : 'Work Visa') + '.';
                    if (isRestricted) {
                        message += ' Reduce their number of scheduled days per week up to (' + warning.value + ' days)';
                    }
                    else {
                        message += ' Scheduled over ' + warning.value + ' days per week';
                    }

                    break;

                case 'MINOR_ROLLING_24_HOURS':
                    if (isRestricted) {
                        message = 'Minor. Reduce their maximum hours per '+  warning.period_length + '-hrs period up to ' + (warning.value / 3600) + ' hours';
                    } else {
                        message = 'Minor. Scheduled over ' + (warning.value / 3600) + ' hours per ' + warning.period_length + '-hrs period';
                    }

                    break;

                case warning.restrictionType + '_' +'EMPLOYEE_EXCEEDS_HOURS_PER_WEEK':
                    message = (warning.restrictionType === 'MINOR' ? 'Minor' : 'Work Visa') + '.';
                    if (isRestricted) {
                        message += ' Reduce their maximum hours per week up to (' + (warning.value / 3600) + ' hrs)';
                    }
                    else {
                        message += ' Scheduled over ' + (warning.value / 3600) + ' hours per week';
                    }

                    break;

                case 'MINOR_MAX_COMBINED_HOURS_PER_DAY':
                    if (isRestricted) {
                        message = 'Minor. Reduce their maximum combined hours of school and work per day (' + (warning.value / 3600) + ' hrs)';
                    }
                    else {
                        message = 'Minor. Scheduled over ' + (warning.value / 3600) + ' maximum combined hours of school and work per day';
                    }
                    message += (self.viewType === 'WEEKLY'? ' for ' + day: '');
                    break;

                case 'MINOR_MAX_HOURS_PER_DAY':
                    if (isRestricted) {
                        message = 'Minor. Reduce their maximum hours per day up to (' + (warning.value / 3600) + ' hrs)';
                    }
                    else {
                        message = 'Minor. Scheduled over ' + (warning.value / 3600) + ' hours per day';
                    }
                    message += (self.viewType === 'WEEKLY'? ' for ' + day: '');
                    break;

                case 'PROHIBITED_HOURS':
                    if (warning.sub_key == 'before_shift_earliest_time') {
                        var startTime = new moment();
                        startTime.hours(warning.value / 3600);
                        startTime.minutes((warning.value % 3600) / 60);
                        startTime.seconds(0);
                        if (isRestricted) {
                            message = 'Minor. Start their shift after ' + startTime.format('hh:mm a');
                        }
                        else {
                            message = 'Minor. Shifts start before the permitted time at ' + startTime.format('hh:mm a');
                        }
                        message +=  (self.viewType === 'WEEKLY'? ' for ' + day: '');
                    }
                    else if (warning.sub_key == 'after_shift_latest_time') {
                        var endTime = new moment();
                        endTime.hours(warning.value / 3600);
                        endTime.minutes((warning.value % 3600) / 60);
                        endTime.seconds(0);
                        if (isRestricted) {
                            message = 'Minor. End their shift before ' + endTime.format('hh:mm a');
                        }
                        else {
                            message = 'Minor. Shifts end after the permitted time at ' + endTime.format('hh:mm a');
                        }
                        message += (self.viewType === 'WEEKLY'? ' for ' + day: '');
                    }

                    break;
                case 'BEFORE_VISA_START_DATE':
                case 'AFTER_VISA_END_DATE':
                    if (!isRestricted) {
                        message = $filter('translate')('Work Visa') +'. '+ $filter('translate')('Outside the visa dates');
                    }
                    else {
                        if (warning.key == 'AFTER_VISA_END_DATE') {
                            message = $filter('translate')('The employee has a work visa which ended on') + ' ' + warning.date + ' ' + $filter('translate')('and can no longer have shifts added') + '.';
                        }
                        else if (warning.key == 'BEFORE_VISA_START_DATE') {
                            message = $filter('translate')('The employee has a work visa which starts on') + ' ' + warning.date + '. ' + $filter('translate')('You can add shifts to them from this date') + '.';
                        }
                    }

                    break;

                case self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_PER_WEEK.code:
                    if (isRestricted) {
                        message = `${$filter('translate')('Minor. Increase their rest period hours per week up to a minimum of')} (${warning.value} hours)`;
                    } else {
                        message = $filter('translate')('Minor. Not enough scheduled rest hours per week');
                    }

                    break;

                case self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_BETWEEN_SHIFTS.code:
                    if (isRestricted) {
                        message = `${$filter('translate')('Minor. Increase their rest period hours between shifts up to a minimum of')} ${warning.value} hours.`;
                    } else {
                        message = $filter('translate')('Minor. Not enough scheduled rest hours between shifts');
                    }
                    break;
            }

            return message;
        };


        self.checkEmployeeWarnings = function (userId) {
            self.scheduleWarnings = {};
            self.warnings = {
                shifts: {},
                shadows: {},
                users: {},
                costs: (self.warnings && self.warnings['costs']) || {}
            };

            var userData = scheduleDataServiceV2.flatData['users'][userId];

            if (userData) {

                for (var i in userData.shift_ids) {
                    var shiftId = userData.shift_ids[i];
                    var shift1 = scheduleDataServiceV2.flatData['shifts'][shiftId];
                    self.warnings.shifts[shiftId] = [];
                    if (shift1.employee_consent && shift1.employee_consent.status === 'PENDING_EMPLOYEE_APPROVAL') {
                        self.warnings.shifts[shiftId].push({code: 'PENDING_EMPLOYEE_CONSENT'});
                    }
                }
            }
        };

        var hasDayOfRestWarning = function (weekDaysKeys, workingDaysArray) {
            for (var i = 0; i < weekDaysKeys.length-1; i++) {
                var j = i + 1;
                var currentDay = workingDaysArray[weekDaysKeys[i]] || {};
                var nextDay = workingDaysArray[weekDaysKeys[j]] || {};
                if ((_.isEmpty(currentDay.first_assignee_shift) && _.isEmpty(currentDay.last_assignee_shift)) ||
                    (_.isEmpty(nextDay.first_assignee_shift) && _.isEmpty(nextDay.last_assignee_shift))) {
                    return false;
                }
                else {
                    if (nextDay.first_assignee_shift && nextDay.first_assignee_shift.start_time &&
                        currentDay.last_assignee_shift && currentDay.last_assignee_shift.end_time) {
                        var duration = moment.duration(moment(nextDay.first_assignee_shift.start_time).diff(moment(currentDay.last_assignee_shift.end_time)));
                        var hours = duration.asHours();
                        if (hours >= 24) {
                            return false;
                        }
                    }
                }
            }
            return true;
        };

        var getWeekDays = function (date) {
            var weekDays = [];
            for (var i = 0; i < 7; i++) {
                var weekDay = date.clone().add(i, "days");
                var day = {
                    id: weekDay.format("ddd").toUpperCase(),
                    label: weekDay.format("YYYY-MM-DD"),
                    value: weekDay,
                };
                weekDays.push(day);
            }
            return weekDays;
        };

        var checkUserRestWarning = function (userId, maxScheduledDaysSettings) {
            var restWarnings = [];
            var brandStartDayOfWeek = scheduleDataServiceV2.getBrandStartDayOfWeek();

            if (maxScheduledDaysSettings['schedule_max_working_days_week_type'] === 'CALENDAR' && (
                maxScheduledDaysSettings['calendar_start_day'] !== brandStartDayOfWeek ||
                (maxScheduledDaysSettings['calendar_start_day'] === brandStartDayOfWeek &&
                    !(scheduleDataServiceV2.businessDay['close_time'] === 0 && scheduleDataServiceV2.businessDay['open_time'] === 0))
            )) {
                var workingDaysBoundaries = scheduleDataServiceV2.getCalenderWorkingDaysBoundaries();

                var startDayOfPreviousWeek = moment(workingDaysBoundaries['first_half'].start_date);
                var previousWeekDays = getWeekDays(startDayOfPreviousWeek);
                var previousWeekDaysKeys = _.pluck(previousWeekDays, 'label') || [];
                var weekShifts = scheduleDataServiceV2.getShiftsForWeek(userId, previousWeekDaysKeys);
                var userHasDayOfRestWarningOnPreviousWeek = hasDayOfRestWarning(previousWeekDaysKeys, weekShifts);

                if (userHasDayOfRestWarningOnPreviousWeek) {
                    restWarnings.push({
                        code: 'FIRST_HALF_OF_CALENDAR_DAY_OF_REST',
                        week_range: {start_date: previousWeekDaysKeys[0], end_date: previousWeekDaysKeys[previousWeekDaysKeys.length -1]}
                    });
                }

                var startDayOfNextWeek = moment(workingDaysBoundaries['second_half'].start_date);
                var nextWeekDays = getWeekDays(startDayOfNextWeek);
                var nextWeekDaysKeys = _.pluck(nextWeekDays, 'label') || [];
                var weekShifts = scheduleDataServiceV2.getShiftsForWeek(userId, nextWeekDaysKeys);
                var userHasDayOfRestWarningOnNextWeek = hasDayOfRestWarning(nextWeekDaysKeys, weekShifts);
                if (userHasDayOfRestWarningOnNextWeek) {
                    restWarnings.push({
                        code: 'SECOND_HALF_OF_CALENDAR_DAY_OF_REST',
                        week_range: {start_date: nextWeekDaysKeys[0], end_date: nextWeekDaysKeys[nextWeekDaysKeys.length -1]}
                    });
                }
            }
            else {
                var currentWeek = getWeekDays(moment(scheduleDataServiceV2.startDate));
                var currentWeekDaysKeys = _.pluck(currentWeek, 'label') || [];
                var weekShifts = scheduleDataServiceV2.getShiftsForWeek(userId, currentWeekDaysKeys);
                var userHasDayOfRestWarning = hasDayOfRestWarning(currentWeekDaysKeys, weekShifts);

                if (userHasDayOfRestWarning) {
                    restWarnings.push({
                        code: 'BUSINESS_DAY_OF_REST',
                        week_range: {
                            start_date: currentWeekDaysKeys[0],
                            end_date: currentWeekDaysKeys[currentWeekDaysKeys.length - 1]
                        }
                    });
                }
            }
            return restWarnings;
        };

        var prepareWarningsPerUser = function(userId) {
            var warnings = [];
            var weekEndDate = scheduleCostsServiceV2.endDate;
            var isUserPayTypeWeightedShift = false;
            var userData = scheduleDataServiceV2.flatData['users'][userId];
            var newHiresMap = FairSchedulingService.prepareNewlyHiredMap(scheduleDataServiceV2.startDate, true, [userId], 'ROLE_PERSON');
            var newHiresIds = Object.keys(newHiresMap);
            var userDefinedAvailabilities = scheduleDataServiceV2.definedAvailabilities[userId] || [];
            var userCosts = scheduleCostsServiceV2.flatData['costs'][userId];
            var activeScheduleView = scheduleDataServiceV2.getActiveScheduleViewType();
            var scheduleSettings = scheduleDataServiceV2.getBrandScheduleSettings();
            var teamLiveCountryCode = scheduleDataServiceV2.getTeamLiveCountryCode();
            const isMcdLaborModalEnabled = scheduleDataServiceV2.isMcDLaborServiceEnabled;
            const tpchLabel = scheduleSettings.show_cplh ? "CPLH" : (isMcdLaborModalEnabled ? 'TPMH' : 'TPCH');

            self.WARNING_CATEGORIES.TPCH_VIOLATIONS = {
                code: 'TPCH_VIOLATIONS',
                name: `${$filter('translate')('Minimum')} ${tpchLabel} ${$filter('translate')('target')}`,
                description: `${$filter('translate')('Make sure to meet the')} ${tpchLabel} ${$filter('translate')('target of')} `,
                warningLevel: self.WARNING_LEVELS.SCHEDULE_LEVEL,
            };

            if (teamLiveCountryCode !== 'PH' &&
                scheduleSettings['max_scheduled_days'] &&
                scheduleSettings['max_scheduled_days']['schedule_max_working_days_week_type'] !== 'NONE') {
                var maxScheduledDaysSettings = scheduleSettings['max_scheduled_days'];
                var restWarnings = checkUserRestWarning(userId, maxScheduledDaysSettings);
                if (restWarnings.length) {
                    for (var w in restWarnings) {
                        var warning = restWarnings[w];
                        if (warning.code === 'FIRST_HALF_OF_CALENDAR_DAY_OF_REST' || warning.code === 'SECOND_HALF_OF_CALENDAR_DAY_OF_REST') {
                            self.WARNING_SUB_CATEGORIES[warning.code].name = moment(warning['week_range'].start_date).format('MMM DD, YYYY') +
                                ' - ' + moment(warning['week_range'].end_date).format('MMM DD, YYYY');
                        }
                        warnings.push({
                            code: warning.code,
                            week_range : {start_date: warning['week_range'].start_date, end_date: warning['week_range'].end_date}
                        });

                    }
                }
            }

            var activeScheduleDay = activeScheduleView && activeScheduleView.id === 'DAILY' ? scheduleDataServiceV2.getActiveScheduleDay() : scheduleDataServiceV2.startDate;
            var isPhilippinesMinWeeklyHoursEnabled = scheduleDataServiceV2.isPhilippinesMinWeeklyHoursEnabled();
            var userPhilippinesMinWeeklyHoursWarnings = PhilippinesMinWeeklyHoursService.calculateMinWeeklyHoursWarnings({userId: userId});

            if (newHiresIds.indexOf(userId.toString()) > -1) {
                warnings.push({code: 'NEW_HIRED_EMPLOYEE'});
            }
            if (scheduleCostsServiceV2.flatData['costs'][userId] && (scheduleCostsServiceV2.flatData['costs'][userId].deactivated || scheduleCostsServiceV2.flatData['costs'][userId].mode == 'GUEST')) {
                warnings.push({code: 'DEACTIVATED'});
            }

            for (var i in userData.shift_ids) {
                var noSchoolCalenderArrayWarnings = warnings.filter(existingWarning => (existingWarning.code).includes('EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR'));
                var minorWarningIndex = _.findIndex(noSchoolCalenderArrayWarnings, {restrictionType: 'MINOR'});
                var workVisaWarningIndex = _.findIndex(noSchoolCalenderArrayWarnings, {restrictionType: 'WORK_VISA'});

                if (minorWarningIndex == -1) {
                    var shiftMinorRulesWarning = MinorSchedulingService.minorWarningsPerShift[userData.shift_ids[i]] || [];
                    var warningExists = shiftMinorRulesWarning.find(minorWarning => (minorWarning.key).includes('EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR'));
                    if (warningExists) {
                        warningExists.code = warningExists.key;
                        warnings.push(warningExists);
                    }
                }

                if (workVisaWarningIndex == -1) {
                    var shiftWorkVisasRulesWarning = WorkVisasService.workVisasWarningsPerShift[userData.shift_ids[i]] || [];
                    var warningExists = shiftWorkVisasRulesWarning.find(workRestrictionWarning => (workRestrictionWarning.key).includes('EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR'));
                    if (warningExists) {
                        warningExists.code = warningExists.key;
                        warnings.push(warningExists);
                    }
                }

            }

            if (gfeWarnings && gfeWarnings.length) {
                var rowWarnings = getGFEWarningsTypeList('ROW');
                var id = parseInt(userId);
                var gfeUserWarnings = _.filter(gfeWarnings, function (gfeWarning) {
                    return gfeWarning.userId === id;
                });

                for (var w in gfeUserWarnings) {
                    var gfeRowWarning = gfeUserWarnings[w];

                    if (
                        (
                            gfeRowWarning.code === 'NO_EFFECTIVE_GFE' ||
                            gfeRowWarning.code === 'NO_EFFECTIVE_REGULAR_SCHEDULE'
                        ) &&
                        activeScheduleView.id === 'DAILY' &&
                        gfeRowWarning.nonCoveredDays &&
                        gfeRowWarning.nonCoveredDays.length
                    ) {
                        var applied = false;

                        for (var index = 0; index < gfeRowWarning.nonCoveredDays.length; index++) {
                            if (moment(gfeRowWarning.nonCoveredDays[index]).isSame(activeScheduleDay)) {
                                applied = true;
                                break;
                            }
                        }

                        if (!applied) {
                            continue;
                        }
                    }

                    if (rowWarnings.indexOf(gfeRowWarning.code) > -1) {
                      warnings.push(gfeUserWarnings[w]);
                    }
                }
            }

            if (userCosts && userCosts[scheduleCostsServiceV2.SHIFT_WARNINGS.WEEKLY_OVERTIME]) {
                warnings.push({code: 'WEEKLY_OVERTIME'});
            }

            if (userCosts && userCosts[scheduleCostsServiceV2.SHIFT_WARNINGS.WEEKLY_GUEST_OVERTIME]) {
                warnings.push({code: 'MAX_GUEST_WEEKLY_HOURS'});
            }

            if (userCosts && userCosts[scheduleCostsServiceV2.SHIFT_WARNINGS.PH_REST_DAY] && scheduleDataServiceV2.checkIfUserScheduled(userId)) {
                warnings.push({code: 'PH_REST_DAY_OVERTIME', restDay: userCosts['rest_day']});
            }

            if (userCosts && scheduleCostsServiceV2.hasWeightedShiftPayType()) {
                var userPayType = userCosts && userCosts["pay_type"] && userCosts["pay_type"][weekEndDate] && userCosts["pay_type"][weekEndDate].type;
                var brandSalariedTrack = scheduleCostsServiceV2.getBrandTrackMode();

                isUserPayTypeWeightedShift = userPayType && (
                    (userPayType === scheduleCostsServiceV2.PAY_TYPES.WEIGHTED_SHIFT ||
                        (userPayType === scheduleCostsServiceV2.PAY_TYPES.SALARIED &&
                            brandSalariedTrack === scheduleCostsServiceV2.PAY_TYPES.WEIGHTED_SHIFT))
                );
            }

            const userShiftsCount = userCosts?.shifts_per_week?.[weekEndDate]?.value;
            if (
                self.checkIfWarningEnabled(self.WARNING_SUB_CATEGORIES.BELOW_CONTRACTED_SHIFTS.code) &&
                isUserPayTypeWeightedShift &&
                scheduleCostsServiceV2.userScheduledShifts[userId] < userShiftsCount
            ) {
                warnings.push({
                    code: self.WARNING_SUB_CATEGORIES.BELOW_CONTRACTED_SHIFTS.code,
                    shifts_count: userShiftsCount
                });
            } else if (
                self.checkIfWarningEnabled(self.WARNING_SUB_CATEGORIES.OVER_CONTRACTED_SHIFTS.code) &&
                isUserPayTypeWeightedShift &&
                scheduleCostsServiceV2.userScheduledShifts[userId] > userShiftsCount
            ) {
                warnings.push({
                    code: self.WARNING_SUB_CATEGORIES.OVER_CONTRACTED_SHIFTS.code,
                    shifts_count: userShiftsCount
                });
            }

            if (userPhilippinesMinWeeklyHoursWarnings.length) {
                warnings.push(userPhilippinesMinWeeklyHoursWarnings[0]);
            }

            if (self.checkIfWarningEnabled(self.WARNING_CATEGORIES.UNDEFINED_AVAILABILITY.code) && userDefinedAvailabilities.length === 0 && scheduleDataServiceV2.flatData['users'][userId]['shift_ids'].length) {
                warnings.push({code: 'UNDEFINED_AVAILABILITY'});
            }

            if (
                MinorSchedulingService.minorsWarning &&
                MinorSchedulingService.minorsWarning[userId] &&
                Object.keys(MinorSchedulingService.minorsWarning[userId]).length
            ) {
                for (var i in MinorSchedulingService.minorsWarning[userId]) {
                    var minorWarning = angular.copy(MinorSchedulingService.minorsWarning[userId][i]);
                    var minorWarningCode = minorWarning.key;

                    if (self.WARNING_SUB_CATEGORIES[minorWarningCode].warningLevel === self.WARNING_LEVELS.EMPLOYEE_LEVEL) {
                        var warningIndex = warnings.findIndex(function (warning) {
                            return warning.code === minorWarningCode;
                        });
                        if (warningIndex === -1) {
                            minorWarning.code = minorWarningCode;
                            warnings.push(minorWarning);
                        }
                    }
                }
            }

            if (
                WorkVisasService.workVisasUsersWarning &&
                WorkVisasService.workVisasUsersWarning[userId] &&
                Object.keys(WorkVisasService.workVisasUsersWarning[userId]).length
            ) {
                for (var i in WorkVisasService.workVisasUsersWarning[userId]) {
                    var workVisaWarning = angular.copy(WorkVisasService.workVisasUsersWarning[userId][i]);
                    var workVisaWarningCode = workVisaWarning.key;
                    if (
                        self.WARNING_SUB_CATEGORIES[workVisaWarningCode].warningLevel === self.WARNING_LEVELS.EMPLOYEE_LEVEL) {
                        var warningIndex = warnings.findIndex(function (warning) {
                            return warning.code === workVisaWarningCode;
                        });
                        if (warningIndex === -1) {
                            workVisaWarning.code = workVisaWarningCode;
                            warnings.push(workVisaWarning);
                        }
                    }
                }
            }

            if (scheduleCostsServiceV2.userOptInWorkLimitHoursMap[userId]?.hours > scheduleDataServiceV2.WORK_LIMIT_HOURS) {
                warnings.push({code: self.WARNING_SUB_CATEGORIES.OVER_WORK_LIMIT.code});
            }

            const isOverWorkingPatternsSettingEnabled = self.checkIfWarningEnabled(self.WARNING_SUB_CATEGORIES.OVER_DAYS_AND_HOURS_PER_WEEK.code);
            const isBelowWorkingPatternsSettingEnabled = self.checkIfWarningEnabled(self.WARNING_SUB_CATEGORIES.BELOW_DAYS_AND_HOURS_PER_WEEK.code);
            const userMaxWeeklyHours = userCosts.max_weekly_hours[weekEndDate] || {};
            const userWorkingPatternsWarnings = workingPatternsWarningsFactory.getWorkingPatternsWarnings(userMaxWeeklyHours, scheduleCostsServiceV2.userDailyHoursMap[userId] || {});
            const daysCount = userMaxWeeklyHours?.working_pattern?.days_count ?? userMaxWeeklyHours?.working_pattern?.working_pattern_days.length;
            // Below/Over contracted hours warnings
            if (
                self.checkIfWarningEnabled(self.WARNING_SUB_CATEGORIES.BELOW_CONTRACTED_HOURS.code) &&
                scheduleDataServiceV2.isBrandUK &&
                !isPhilippinesMinWeeklyHoursEnabled &&
                userWorkingPatternsWarnings?.belowHours
            ) {
                warnings.push({
                    code: self.WARNING_SUB_CATEGORIES.BELOW_CONTRACTED_HOURS.code,
                    hours_count: userMaxWeeklyHours.value,
                });
            } else if (
                self.checkIfWarningEnabled(self.WARNING_SUB_CATEGORIES.OVER_CONTRACTED_HOURS.code) &&
                !isPhilippinesMinWeeklyHoursEnabled &&
                userWorkingPatternsWarnings?.overHours
            ) {
                warnings.push({
                    code: self.WARNING_SUB_CATEGORIES.OVER_CONTRACTED_HOURS.code,
                    hours_count: userMaxWeeklyHours.value,
                });
            }
            // Over working patterns warnings
            if (isOverWorkingPatternsSettingEnabled && userWorkingPatternsWarnings?.overDays && userWorkingPatternsWarnings?.overHours) {
                warnings.push({
                    code: self.WARNING_SUB_CATEGORIES.OVER_DAYS_AND_HOURS_PER_WEEK.code,
                    days_count: daysCount,
                    hours_count: userMaxWeeklyHours.value,
                });
            } else if (isOverWorkingPatternsSettingEnabled && userWorkingPatternsWarnings?.overDays) {
                warnings.push({
                    code: self.WARNING_SUB_CATEGORIES.OVER_DAYS_PER_WEEK.code,
                    days_count: daysCount,
                });
            } else if (isOverWorkingPatternsSettingEnabled && userWorkingPatternsWarnings?.overHours) {
                warnings.push({
                    code: self.WARNING_SUB_CATEGORIES.OVER_HOURS_PER_WEEK.code,
                    hours_count: userMaxWeeklyHours.value,
                });
            }
            // Wrong hours for specific day warning
            if (isOverWorkingPatternsSettingEnabled && userWorkingPatternsWarnings?.daysWithWrongHours) {
                for (const day of userWorkingPatternsWarnings.daysWithWrongHours) {
                    warnings.push({
                        code: self.WARNING_SUB_CATEGORIES.WRONG_HOURS_FOR_DAY.code,
                        date: day.date,
                        hours_count: day.hours_count,
                    });
                }
            }
            // Below working patterns warnings
            if (isBelowWorkingPatternsSettingEnabled && userWorkingPatternsWarnings?.belowDays && userWorkingPatternsWarnings?.belowHours) {
                warnings.push({
                    code: self.WARNING_SUB_CATEGORIES.BELOW_DAYS_AND_HOURS_PER_WEEK.code,
                    days_count: daysCount,
                    hours_count: userMaxWeeklyHours.value,
                });
            } else if (isBelowWorkingPatternsSettingEnabled && userWorkingPatternsWarnings?.belowDays) {
                warnings.push({
                    code: self.WARNING_SUB_CATEGORIES.BELOW_DAYS_PER_WEEK.code,
                    days_count: daysCount,
                });
            } else if (isBelowWorkingPatternsSettingEnabled && userWorkingPatternsWarnings?.belowHours) {
                warnings.push({
                    code: self.WARNING_SUB_CATEGORIES.BELOW_HOURS_PER_WEEK.code,
                    hours_count: userMaxWeeklyHours.value,
                });
            }

            return warnings;
        };

        var getOverlappedShifts = function (shiftId, userId, includeExtended) {
            var shift1 = scheduleDataServiceV2.flatData['shifts'][shiftId];
            var userData = scheduleDataServiceV2.flatData['users'][userId];
            var crossLocationsUsers = scheduleDataServiceV2.getCrossLocationsUsersData();
            var userCrossLocationShifts = crossLocationsUsers[userId] || [];
            var overlappedShifts = [];
            var overlappedCrossLocationShifts = [];

            for (var j in userData.shift_ids) {
                var otherShiftId = userData.shift_ids[j];
                var shift2 = scheduleDataServiceV2.flatData['shifts'][otherShiftId];
                if (doOverlap(shift1, shift2) && otherShiftId !== shiftId) {
                    overlappedShifts.push(shift2);
                }
            }
            if (includeExtended && scheduleDataServiceV2.extraDayFlatData['extended_shifts']) {
                for (var e in scheduleDataServiceV2.extraDayFlatData['extended_shifts']) {
                    var extendedShift = scheduleDataServiceV2.extraDayFlatData['extended_shifts'][e];
                    if (shift1.user_id === extendedShift.user_id && doOverlap(shift1, extendedShift)) {
                        overlappedShifts.push(extendedShift);
                    }
                }
            }

            for (var j in userCrossLocationShifts) {
                if (doOverlap(shift1, userCrossLocationShifts[j])) {
                    overlappedCrossLocationShifts.push(userCrossLocationShifts[j]);
                }
            }
          return {shifts:overlappedShifts, cross_location_shifts: overlappedCrossLocationShifts};
        };

        var prepareWarningsPerShift = function (shiftId) {
            var warnings = [];
            var scheduleSettings = scheduleDataServiceV2.getBrandScheduleSettings();
            var isScheduledBreaksEnabled = scheduleSettings && scheduleSettings['shift_break_times_mode'] === "MANUAL_ENTRY";
            var shift1 = scheduleDataServiceV2.flatData['shifts'][shiftId];
            var userAvailabilities = scheduleDataServiceV2.availabitlies[shift1.user_id] || [];
            var minorAvailabilities = WorkRestrictionsService.minorUsersSchoolCalenders && WorkRestrictionsService.minorUsersSchoolCalenders[shift1.user_id];
            var overlappedShifts = getOverlappedShifts(shiftId, shift1.user_id, true);

            if (overlappedShifts.shifts.length || overlappedShifts.cross_location_shifts.length) {
                warnings.push({code: 'OVERLAP', shifts: overlappedShifts.shifts,cross_location_shifts: overlappedShifts.cross_location_shifts});
            }

            if (self.reportingTimeShiftsWarningsMap[shift1.id]) {
                warnings.push({code: self.WARNING_CATEGORIES.CALL_INS.code});
            }

            if (self.checkIfWarningEnabled(self.WARNING_CATEGORIES.UNSCHEDULED_BREAKS.code) && isScheduledBreaksEnabled && shift1.status !== 'DELETED') {
             if (shift1.breaks && shift1.breaks.length) {
                 if (!shift1.breaks[0].start_time) {
                     warnings.push({code: 'UNSCHEDULED_BREAKS'});
                 }
             }
            }

            for (var j in userAvailabilities) {
                if (['PREFERRED_TIME', 'WORKABLE', 'LOA'].indexOf(userAvailabilities[j].type) === -1 && doOverlap(shift1, userAvailabilities[j])) {
                    var availabilityWarningCode = userAvailabilities[j].type;
                    if (!self.checkIfWarningEnabled(availabilityWarningCode)) {
                        continue;
                    }
                    if (["PATERNITY", "BEREAVEMENT", "MATERNITY", "SHARED_PARENTAL", "ADOPTION", "CUSTOM", "COMPANY_HOLIDAY", "STATUTORY_HOLIDAY", "UNAUTHORIZED", "SHARED_PARENTAL_ADOPTION"].indexOf(userAvailabilities[j].type) > -1) {
                        availabilityWarningCode = 'ABSENCE';
                    }
                    var availabilityWarningIndex = warnings.findIndex(function (warn) {
                        return warn.code === availabilityWarningCode;
                    });
                    if (availabilityWarningIndex === -1) {
                        warnings.push({code: availabilityWarningCode});
                    }
                }
                }

            if (minorAvailabilities && Object.keys(minorAvailabilities).length) {
                for (var j in minorAvailabilities) {
                    if (
                        minorAvailabilities[j].type === WorkRestrictionsService.PERIOD_TYPES.SCHOOL_DAY &&
                        doOverlap(shift1, minorAvailabilities[j])
                    ) {
                        warnings.push({code:'IN_SCHOOL_TIME'});
                        break;
                    }
                }
            }

            if (scheduleDataServiceV2.markedOffDays && scheduleDataServiceV2.markedOffDays[shift1.user_id]) {
                var markedDay = scheduleDataServiceV2.markedOffDays[shift1.user_id].find(function (day) {
                    return (
                        moment(day.date).isSame(moment(shift1.day), 'day')
                        ||moment(day.date).isSame(moment(shift1.end_time), 'day')
                        || moment(day.date).isSame(moment(shift1.start_time), 'day')
                    );
                });

                if (markedDay) {
                    var markedAs = markedDay.markAs || markedDay.type;
                    warnings.push({
                        code: 'MARKED_DAY',
                        markAs: markedAs.toLowerCase(),
                        user: tsUsersService.users[shift1.user_id],
                        day: moment(markedDay.date).format('dddd')
                    });
                }
            }

            if (scheduleDataServiceV2.flatData['shifts'][shiftId]['costInfo']['exceeded_daily_overtime']) {
                warnings.push({code:'DAILY_OVERTIME'});
            }

            if (scheduleDataServiceV2.flatData['shifts'][shiftId]['costInfo']['exceeded_daily_double_overtime']) {
                warnings.push({code:'DAILY_DOUBLE_OVERTIME'});
            }

            if (scheduleDataServiceV2.flatData['shifts'][shiftId]['costInfo']['exceeded_spread_of_hours']) {
                warnings.push({code:'SPREAD_OF_HOURS'});
            }

            if (scheduleDataServiceV2.flatData['shifts'][shiftId]['costInfo']['exceeded_weekly_consecutive_overtime'] ||
                scheduleDataServiceV2.flatData['shifts'][shiftId]['costInfo']['exceeded_weekly_consecutive_double_overtime']) {
                warnings.push({code:'SEVENTH_CONSECUTIVE_OVERTIME'});
            }


            if (scheduleDataServiceV2.flatData['shifts'][shiftId]['costInfo']['split_shift_premium_applied']) {
                warnings.push({code:'SPLIT_SHIFT_PREMIUMS'});
            }

            if (gfeWarnings && gfeWarnings.length) {
                var shiftWarnings = getGFEWarningsTypeList('SHIFT');
                var shiftGFEWarnings = _.filter(gfeWarnings, function (gfeWarning) {
                    var gfeShiftId = gfeWarning.shift && gfeWarning.shift.id;
                    return gfeShiftId === shiftId;
                });

                for (var w in shiftGFEWarnings) {
                    var gfeShiftWarning = shiftGFEWarnings[w];
                    if (shiftWarnings.indexOf(gfeShiftWarning.code) > -1) {
                        var gfeShiftWarningExisit = warnings.find(function (warn) {
                            return warn.code === gfeShiftWarning.code;
                        });
                        if (!gfeShiftWarningExisit) {
                            warnings.push(gfeShiftWarning);
                        }
                    }
                }
            }

            if (
                scheduleDataServiceV2.flatData['shifts'][shiftId].job_titles &&
                scheduleDataServiceV2.flatData['shifts'][shiftId].job_titles.length &&
                scheduleDataServiceV2.usersJobTiles &&
                Object.keys(scheduleDataServiceV2.usersJobTiles).length
            ) {
                var userJobTile = scheduleDataServiceV2.usersJobTiles[shift1.user_id] || {};

                for (var t in scheduleDataServiceV2.flatData['shifts'][shiftId].job_titles) {
                    var jobTitle = scheduleDataServiceV2.flatData['shifts'][shiftId].job_titles[t];
                    var jobTitleLevel = userJobTile[jobTitle.job_title_id] && userJobTile[jobTitle.job_title_id].level;
                    var skillLevelWarningObj = warnings.find(function (warn) {
                       return warn.code === 'SKILL_LEVEL_4_OR_5';
                    });

                    if (self.checkIfWarningEnabled(self.WARNING_SUB_CATEGORIES.SKILL_LEVEL_4_OR_5.code) && [4, 5].indexOf(jobTitleLevel) > -1) {
                        if (!skillLevelWarningObj) {
                            skillLevelWarningObj = {code: 'SKILL_LEVEL_4_OR_5', levels: []};
                            warnings.push(skillLevelWarningObj);
                        }
                        if (skillLevelWarningObj.levels.indexOf(jobTitleLevel) === -1) {
                            skillLevelWarningObj.levels.push(jobTitleLevel)
                        }

                    }

                    if (self.checkIfWarningEnabled(self.WARNING_SUB_CATEGORIES.UNDEFINED_JOB_TITLE_LEVEL.code) && !jobTitleLevel && warnings.indexOf('UNDEFINED_JOB_TITLE_LEVEL') === -1) {
                        warnings.push({code:'UNDEFINED_JOB_TITLE_LEVEL'});
                    }
                }
            }

            if (
                MinorSchedulingService.minorsWarning &&
                MinorSchedulingService.minorsWarning[shift1.user_id] &&
                Object.keys(MinorSchedulingService.minorsWarning[shift1.user_id]).length
            ) {
                for (var i in MinorSchedulingService.minorsWarning[shift1.user_id]) {
                    var minorWarning = angular.copy(MinorSchedulingService.minorsWarning[shift1.user_id][i]);
                    var minorWarningCode = minorWarning.key;
                    if (self.WARNING_SUB_CATEGORIES[minorWarningCode].warningLevel === self.WARNING_LEVELS.SHIFT_LEVEL) {
                        minorWarning.code = minorWarningCode;
                        warnings.push(minorWarning);
                    }
                }
            }
            if (
                WorkVisasService.workVisasUsersWarning &&
                WorkVisasService.workVisasUsersWarning[shift1.user_id] &&
                Object.keys(WorkVisasService.workVisasUsersWarning[shift1.user_id]).length
            ) {
                for (var i in WorkVisasService.workVisasUsersWarning[shift1.user_id]) {
                    var workVisaWarning = angular.copy(WorkVisasService.workVisasUsersWarning[shift1.user_id][i]);
                    var workVisaWarningCode = workVisaWarning.key;
                    if (self.WARNING_SUB_CATEGORIES[workVisaWarningCode].warningLevel === self.WARNING_LEVELS.SHIFT_LEVEL) {
                        workVisaWarning.code = workVisaWarningCode;
                        warnings.push(workVisaWarning);
                    }
                }
            }
            var minorRulesWarning = MinorSchedulingService.minorWarningsPerShift[shift1.id] || [];
            var workVisaWarnings = WorkVisasService.workVisasWarningsPerShift[shift1.id] || [];

            if (minorRulesWarning.length) {
                for (var w in minorRulesWarning) {
                    var minorWarning = angular.copy(minorRulesWarning[w]);
                    var minorWarningCode = minorWarning.key;
                    var warningIndex = _.findIndex(warnings,{code: minorWarningCode});
                    if (!minorWarningCode.includes('MINOR_EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR') &&
                        warningIndex === -1) {
                        minorWarning.code = minorRulesWarning[w].key;
                        switch (minorWarning.code) {
                            case self.WARNING_SUB_CATEGORIES.MINOR_ROLLING_24_HOURS.code:
                                const period = minorWarning.period_length + '-hrs';
                                self.WARNING_SUB_CATEGORIES[minorWarning.code].name = `${$filter('translate')('Over hours per')} ${period} ${$filter('translate')('period')}`;
                                self.WARNING_SUB_CATEGORIES[minorWarning.code].description = `${$filter('translate')('Over the total')} ${period} ${$filter('translate')('period scheduled hours allowed')}`;
                                break;
                            case self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_BETWEEN_SHIFTS.code:
                                self.WARNING_SUB_CATEGORIES[minorWarning.code].description = `${$filter('translate')('Below the required minimum rest hours of ')} ${minorWarning.value} between shifts.`;
                                break;
                            default:
                                break;
                        }
                        warnings.push(minorWarning);
                    }
                }
            }

            if (workVisaWarnings.length) {
                for (var w in workVisaWarnings) {
                    var workVisaWarning = angular.copy(workVisaWarnings[w]);
                    var workVisaWarningCode = workVisaWarning.key;
                    var warningIndex = _.findIndex(warnings,{code: workVisaWarningCode});
                    if (!workVisaWarningCode.includes('EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR') &&
                        warningIndex === -1) {
                        workVisaWarning.code = workVisaWarning[w].key;
                        warnings.push(workVisaWarning);
                    }
                }
            }

            if (penaltiesWarnings && penaltiesWarnings.length && !shift1.isExtendedFromPreviousDay) {
                for (var p in penaltiesWarnings) {
                    var penaltyItem = penaltiesWarnings[p];

                    if (
                        (penaltyItem.toShift && penaltyItem.toShift.id === shift1.id) ||
                        (penaltyItem.type === "LENGTH_DECREMENT" && !penaltyItem.toShift && penaltyItem.fromShift.reference_id === shift1.id)
                    ) {
                        penaltyItem.code = penaltyItem.type;
                        warnings.push(penaltyItem);
                    }
                }
            }

            if (restBetweenDaysWarnings && restBetweenDaysWarnings.length && !shift1.isExtendedFromPreviousDay) {
                for (var p in restBetweenDaysWarnings) {
                    var restBetweenDaysWarning = restBetweenDaysWarnings[p];

                    if (restBetweenDaysWarning.toShift.id === shift1.id) {
                        restBetweenDaysWarning.code = 'REST_BETWEEN_DAYS';
                        warnings.push(restBetweenDaysWarning);
                    }
                }
            }

            if (shift1.employee_consent && shift1.employee_consent.status === 'PENDING_EMPLOYEE_APPROVAL') {
                warnings.push({code: 'PENDING_EMPLOYEE_CONSENT'});
            }

            const weekEndDate = scheduleCostsServiceV2.endDate;
            const maxWeeklyHours = scheduleCostsServiceV2.flatData.costs[shift1.user_id].max_weekly_hours[weekEndDate];
            if (self.checkIfWarningEnabled(self.WARNING_SUB_CATEGORIES.SCHEDULED_ON_WRONG_DAY.code) && workingPatternsWarningsFactory.isUserWorkingOnDayOffPattern(maxWeeklyHours, shift1)) {
                warnings.push({
                    code: self.WARNING_SUB_CATEGORIES.SCHEDULED_ON_WRONG_DAY.code,
                    day: moment(shift1.day).format('dddd')
                });
            }

            return warnings;
        };

        self.checkForWarnings = function (filteredUserIds) {

            self.scheduleWarnings = {};

            self.warnings = {
                shifts: {},
                shadows: {},
                users: {},
                costs: (self.warnings && self.warnings['costs']) || {}
            };

            self.reportingTimeShiftsWarningsMap = scheduleCostsServiceV2.reportingTimeShiftsMap;

            var users = {};
            if (filteredUserIds) {
                for (var u in filteredUserIds) {
                    var id = filteredUserIds[u];
                    users[id] = scheduleDataServiceV2.flatData['users'][id];
                }
            } else {
                users = scheduleDataServiceV2.flatData['users'];
            }

            for (var userId in users) {
            var userData = users[userId];
                var crossLocationsUsers = scheduleDataServiceV2.getCrossLocationsUsersData();
                var userCrossLocationShifts = crossLocationsUsers[userId] || [];
                self.warnings['shadows'][userId] = { roles: {} };


                if (!isNaN(userId)) {
                    var userWarnings = prepareWarningsPerUser(userId);
                    self.warnings.users[userId] = userWarnings;
                    for (var i in userWarnings) {
                        var warningCode = userWarnings[i].code;
                        self.scheduleWarnings[warningCode] = self.scheduleWarnings[warningCode] || {
                            code: warningCode,
                            users: [],
                            details: []
                        };
                        if (self.scheduleWarnings[warningCode]['users'].indexOf(userId) === -1) {
                            self.scheduleWarnings[warningCode]['users'].push(userId);
                            self.scheduleWarnings[warningCode]['details'].push({user_id: parseInt(userId)});
                        }
                    }

                    for (var i in userData.shift_ids) {
                        var shiftId = userData.shift_ids[i];
                        var shift1 = scheduleDataServiceV2.flatData['shifts'][shiftId];
                        var shiftWarnings = prepareWarningsPerShift(shiftId);

                        if (userData.role_ids.length > 1) {
                            // Add shadows
                            self.warnings['shadows'][userId]['roles'][shift1.role_id] = self.warnings['shadows'][userId]['roles'][shift1.role_id] || [];
                            self.warnings['shadows'][userId]['roles'][shift1.role_id].push(shift1.id);
                        }
                        self.warnings.shifts[shiftId] = shiftWarnings;
                        for (var k in shiftWarnings) {
                            var shiftWarningsObj = shiftWarnings[k];
                            var shiftWarningCode = shiftWarningsObj.code;
                            self.scheduleWarnings[shiftWarningCode] = self.scheduleWarnings[shiftWarningCode] || {code: shiftWarningCode, users: [], shifts: [], details: [] };

                            if (self.scheduleWarnings[shiftWarningCode]['details'].indexOf(scheduleDataServiceV2.flatData['shifts'][shiftId]['user_id']) === -1) {
                                self.scheduleWarnings[shiftWarningCode]['details'].push(scheduleDataServiceV2.flatData['shifts'][shiftId]);
                            }

                            if (scheduleDataServiceV2.extraDayFlatData['extended_shifts']) {
                                for (var e in scheduleDataServiceV2.extraDayFlatData['extended_shifts']) {
                                    var extendedShift = scheduleDataServiceV2.extraDayFlatData['extended_shifts'][e];

                                    if (shift1.user_id === extendedShift.user_id && doOverlap(shift1, extendedShift)) {
                                        self.warnings.shifts[extendedShift.id] = self.warnings.shifts[extendedShift.id] || [];

                                        var overlapIndex = _.findIndex(self.warnings.shifts[extendedShift.id], {code: 'OVERLAP'});

                                        if (overlapIndex === -1) {
                                            self.warnings.shifts[extendedShift.id].push({code: 'OVERLAP', shifts: [shift1] });
                                        } else {
                                            var isShiftAlreadyPushed = self.warnings.shifts[extendedShift.id][overlapIndex]['shifts'].find(function (overlappedShift) {
                                                return overlappedShift.id == shift1.id;
                                            });
                                            if (!isShiftAlreadyPushed) {
                                                self.warnings.shifts[extendedShift.id][overlapIndex]['shifts'].push(shift1);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (userData.shift_ids.length) {
                        for (var j in userCrossLocationShifts) {
                            var shift = userCrossLocationShifts[j];
                            var shiftUserId = shift.user_id.toString();

                            if (shift['costInfo']['exceeded_daily_overtime']) {
                                self.scheduleWarnings['DAILY_OVERTIME'] = self.scheduleWarnings['DAILY_OVERTIME'] || {
                                    code: 'DAILY_OVERTIME',
                                    users: [],
                                    details: [],
                                    shifts: []
                                };
                                if (self.scheduleWarnings['DAILY_OVERTIME']['details'].indexOf(shiftUserId) === -1) {
                                    self.scheduleWarnings['DAILY_OVERTIME']['details'].push(shift);
                                }
                            }

                            if (shift['costInfo']['exceeded_daily_double_overtime']) {
                                self.scheduleWarnings['DAILY_DOUBLE_OVERTIME'] = self.scheduleWarnings['DAILY_DOUBLE_OVERTIME'] || {
                                    code: 'DAILY_DOUBLE_OVERTIME',
                                    users: [],
                                    details: [],
                                    shifts: []
                                };
                                if (self.scheduleWarnings['DAILY_DOUBLE_OVERTIME']['details'].indexOf(shiftUserId) === -1) {
                                    self.scheduleWarnings['DAILY_DOUBLE_OVERTIME']['details'].push(shift);
                                }
                            }

                            if (shift['costInfo']['exceeded_weekly_overtime']) {
                                self.scheduleWarnings['WEEKLY_OVERTIME'] = self.scheduleWarnings['WEEKLY_OVERTIME'] || {
                                    code: 'WEEKLY_OVERTIME',
                                    users: [],
                                    details: []
                                };
                                if (self.scheduleWarnings['WEEKLY_OVERTIME']['users'].indexOf(shiftUserId) === -1) {
                                    self.scheduleWarnings['WEEKLY_OVERTIME']['users'].push(shiftUserId);
                                    self.scheduleWarnings['WEEKLY_OVERTIME']['details'].push({user_id: parseInt(shift.user_id)});
                                }
                            }

                            if (shift['costInfo']['exceeded_guest_weekly_overtime']) {
                                self.scheduleWarnings['MAX_GUEST_WEEKLY_HOURS'] = self.scheduleWarnings['MAX_GUEST_WEEKLY_HOURS'] || {
                                    code: 'MAX_GUEST_WEEKLY_HOURS',
                                    users: [],
                                    details: []
                                };
                                if (self.scheduleWarnings['MAX_GUEST_WEEKLY_HOURS']['users'].indexOf(shiftUserId) === -1) {
                                    self.scheduleWarnings['MAX_GUEST_WEEKLY_HOURS']['users'].push(shiftUserId);
                                    self.scheduleWarnings['MAX_GUEST_WEEKLY_HOURS']['details'].push({user_id: parseInt(shift.user_id)});
                                }
                            }

                            if (shift['costInfo']['ph_rest_day'] && scheduleDataServiceV2.checkIfUserScheduled(shiftUserId)) {
                                self.scheduleWarnings['PH_REST_DAY_OVERTIME'] = self.scheduleWarnings['PH_REST_DAY_OVERTIME'] || {
                                    code: 'PH_REST_DAY_OVERTIME',
                                    users: [],
                                    details: []
                                };
                                if (self.scheduleWarnings['PH_REST_DAY_OVERTIME']['users'].indexOf(shiftUserId) === -1) {
                                    self.scheduleWarnings['PH_REST_DAY_OVERTIME']['users'].push(shiftUserId);
                                    self.scheduleWarnings['PH_REST_DAY_OVERTIME']['details'].push({user_id: parseInt(shift.user_id)});
                                }
                            }
                        }
                    }
                }
                else {
                    if (userData.shift_ids && userData.shift_ids.length) {
                        if (self.checkIfWarningEnabled(self.WARNING_CATEGORIES.UNASSIGNED.code)) {
                            self.scheduleWarnings['UNASSIGNED'] = self.scheduleWarnings['UNASSIGNED'] || { code: 'UNASSIGNED' , details: [] };
                        }
                        for (var i in userData.shift_ids) {
                            var id = userData.shift_ids[i];
                            var unassignedShift = scheduleDataServiceV2.flatData['shifts'][id];

                            if (!unassignedShift) {
                                continue;
                            }

                            if (self.checkIfWarningEnabled(self.WARNING_CATEGORIES.UNASSIGNED.code)) {
                                self.scheduleWarnings['UNASSIGNED']['details'].push(unassignedShift);
                            }

                            if (self.reportingTimeShiftsWarningsMap[unassignedShift.id]) {
                                self.warnings.shifts[unassignedShift.id] ??= [];
                                if (!self.warnings.shifts[unassignedShift.id].some(warning => warning.code === self.WARNING_CATEGORIES.CALL_INS.code)) {
                                    self.warnings.shifts[unassignedShift.id].push({code: self.WARNING_CATEGORIES.CALL_INS.code});
                                }
                                self.scheduleWarnings[self.WARNING_CATEGORIES.CALL_INS.code] = self.scheduleWarnings[self.WARNING_CATEGORIES.CALL_INS.code] || {
                                    code: self.WARNING_CATEGORIES.CALL_INS.code,
                                    users: [],
                                    details: [],
                                };
                                self.scheduleWarnings[self.WARNING_CATEGORIES.CALL_INS.code]['details'].push(unassignedShift);
                            }
                        }
                    }
                }
            }
            if (gfeWarnings && gfeWarnings.length) {
                for (var i in gfeWarnings) {
                    var gfeWarning = gfeWarnings[i];
                    if (!tsUsersService.users[gfeWarning.userId]) {
                        continue;
                    }

                    if (filteredUserIds && filteredUserIds.indexOf(gfeWarning.userId) === -1) {
                        continue;
                    }

                    if (gfeWarning.code === 'NOT_SCHEDULED' || gfeWarning.code === 'NYC_NOT_SCHEDULED') {
                        self.scheduleWarnings[gfeWarning.code] = self.scheduleWarnings[gfeWarning.code] || {
                            code: gfeWarning.code,
                            users: [],
                            details: []
                        };
                        var gfeUserId = gfeWarning.userId.toString();
                        if (self.scheduleWarnings[gfeWarning.code]['users'].indexOf(gfeUserId) === -1) {
                            var gfeWarningDetails = {user_id: parseInt(gfeWarning.userId)};
                            self.scheduleWarnings[gfeWarning.code]['users'].push(parseInt(gfeWarning.userId));
                            self.scheduleWarnings[gfeWarning.code]['details'].push(gfeWarningDetails);
                        }
                    }
                }
            }


            if (self.checkIfWarningEnabled(self.WARNING_CATEGORIES.EMPTY_DAYS.code)) {
                if (Object.keys(scheduleDataServiceV2.flatData['days']).length < 7) {
                    self.scheduleWarnings['EMPTY_DAYS'] = { code: 'EMPTY_DAYS' };
                }
                else {
                    for (var dayId in scheduleDataServiceV2.flatData['days']) {
                        if (scheduleDataServiceV2.flatData['days'][dayId].role_ids.length === 0) {
                            self.scheduleWarnings['EMPTY_DAYS'] = { code: 'EMPTY_DAYS' };
                        }
                    }
                }
            }
        };

        var preparePenaltyWarningText = function (penaltyDetails, mode, isRestricted) {
            var message = '';

            if (mode === 'ROW') {
                var message = 'FWW.';
                switch (penaltyDetails.type) {
                    case "RIGHT_TO_REST":
                        if (isRestricted) {
                            message += ' Right to rest.';
                            var restPeriod = (penaltyDetails.rest_period) /3600;
                            if (penaltyDetails.allow_access) {
                                message += ' Extend the period between clopen shifts to at least  ' + Utils.roundFloat(restPeriod, 2) + ' hrs';
                            }
                        }
                        else {
                            message += ' Right to rest breach';

                        }
                        break;

                    case "DATE_TIME_CHANGE":
                        message += ' Premium';
                        if (penaltyDetails.allow_access) {
                            message += ' of ' + _filter("currency")(penaltyDetails.penalty, penaltyDetails.currency, 2);
                        }
                        message+= ' for changing the shift time';
                        break;

                    case "LENGTH_INCREMENT":
                        message += ' Premium';
                        if (penaltyDetails.allow_access) {
                            message += ' of ' + _filter("currency")(penaltyDetails.penalty, penaltyDetails.currency, 2);
                        }
                        message+= ' for additional hours';
                        break;

                    case "LENGTH_DECREMENT":
                        message += ' Premium';
                        if (penaltyDetails.allow_access) {
                            message += ' of ' + _filter("currency")(penaltyDetails.penalty, penaltyDetails.currency, 2);
                        }
                        message+= ' for subtraction hours';
                        break;
                }

            }
            else {
            if (
                penaltyDetails.allow_access &&
                penaltyDetails.type !== 'RIGHT_TO_REST'
            ) {
                message = penaltyDetails.show_undefined_penalty ? ' has an undefined premium pay due to undefined max weekly hours ' : ' has premium pay of ' + _filter("currency")(penaltyDetails.penalty, penaltyDetails.currency, 2);
            }

                switch (penaltyDetails.type) {
                    case "RIGHT_TO_REST":

                        message += ' is scheduled to work during a Right to Rest period' + '.';

                        if (penaltyDetails.allow_access) {

                            let getShiftDateTimeLocationDescription = (shift, brandName) => {

                                let dateTimeFormat = `${_filter('formatDate')(shift.start_time, 'MMM DD, YYYY')} ${_filter('formatDate')(shift.start_time, 'h:mm a')} - ${_filter('formatDate')(shift.end_time, 'h:mm a')}`;

                                return `${dateTimeFormat} at ${brandName}`;
                            };

                            let fromShiftDetails = getShiftDateTimeLocationDescription(penaltyDetails.fromShift, penaltyDetails.source_brand.name);
                            let toShiftDetails = getShiftDateTimeLocationDescription(penaltyDetails.toShift, penaltyDetails.toShift.brand_details.name);
                            let shiftsDetails = `${fromShiftDetails}, and ${toShiftDetails}`;

                            message += ` If the employee works these shifts: ${shiftsDetails},`;

                            let premiumPenaltyText = _filter('currency')(penaltyDetails.penalty, penaltyDetails.currency, 2);
                            message += ` a premium of ${premiumPenaltyText} is owed.`;

                            if (penaltyDetails.isRequiredEmployeeConsent) {
                                message += ` Requires the employee’s consent.`;
                            }
                        }
                        break;

                case "DATE_TIME_CHANGE":
                    if (penaltyDetails.allow_access) {
                        message += ' for changing shift time';
                    } else {
                        message = ' has premium for changing shift time';
                    }
                    break;

                case "LENGTH_INCREMENT":
                    if (penaltyDetails.allow_access) {
                        message += ' for additional hours';
                    } else {
                        message = ' has premium for additional hours';
                    }
                    break;

                case "LENGTH_DECREMENT":
                    if (penaltyDetails.allow_access) {
                        message += ' for subtracting hours';
                    } else {
                        message = ' has premium for subtraction hours';
                    }
                    break;
            }
            }
            return message;
        };

      var getRowWarningEmployeeLevelText = function (warning, userId) {
          var scheduleSettings = scheduleDataServiceV2.getBrandScheduleSettings();
          var maxScheduleDaySettings = scheduleSettings['max_scheduled_days'] || {};
          var publishRestrictionsSettings = scheduleSettings['publish_restriction_settings'] || {};

          if (warning.code === 'WEEKLY_OVERTIME' || warning.code === 'MAX_GUEST_WEEKLY_HOURS') {
              return 'Scheduled over the weekly overtime limit'
          }
          if (warning.code === self.WARNING_SUB_CATEGORIES.BELOW_CONTRACTED_SHIFTS.code) {
              return $filter('translate')(`Scheduled for fewer than their ${warning.shifts_count} contracted shifts.`);
          }

          if (warning.code === self.WARNING_SUB_CATEGORIES.OVER_CONTRACTED_SHIFTS.code) {
              return $filter('translate')(`Scheduled for more than their ${warning.shifts_count} contracted shifts.`);
          }

          if (warning.code === self.WARNING_SUB_CATEGORIES.BELOW_CONTRACTED_HOURS.code) {
              return $filter('translate')(`Scheduled for fewer than their ${warning.hours_count} contracted hours.`);
          }

          if (warning.code === 'BELOW_MIN_WEEKLY_HOURS') {
              var weeklyHoursSettings = scheduleDataServiceV2.getBrandMinWeeklyHoursSettings();
              var minWeeklyThreshold = Utils.roundFloat(weeklyHoursSettings['value'] / 3600)

              if (publishRestrictionsSettings.allow_schedule_publish_with_min_weekly_scheduled_hours_violation) {
                  return $filter('translate')('Min scheduled hours. Not provided with a minimum of') + ' ' + minWeeklyThreshold + ' ' + $filter('translate')('scheduled hours within this week');
              } else {
                  return $filter('translate')('Min scheduled hours. Provide a minimum of') + ' ' + minWeeklyThreshold + ' ' + $filter('translate')('scheduled hours within this week');
              }
          }

          if (warning.code === 'PH_REST_DAY_OVERTIME') {
              var workedDaysStartDate = moment(warning.restDay).clone().subtract(6, 'days').format('MMM DD, YYYY');
              var workedDaysEndDate = moment(warning.restDay).clone().format('MMM DD, YYYY');
              return [$filter('translate')('Scheduled to work 7 consecutive days from'), workedDaysStartDate, $filter('translate')('to'), workedDaysEndDate].join(' ');
          }

          if (warning.code === self.WARNING_SUB_CATEGORIES.OVER_CONTRACTED_HOURS.code) {
              var msg;
              if (['UK', 'DK'].indexOf(scheduleDataServiceV2.teamLiveCountryCode) > -1) {
                  msg = $filter('translate')(`Scheduled for more than their ${warning.hours_count} contracted hours.`);
              } else {
                  msg = $filter('translate')(`Scheduled for more than their ${warning.hours_count} max weekly hours.`);
              }

              return msg;
          }

          if (warning.code === 'UNDEFINED_AVAILABILITY') {
              return 'No availability submitted for this week';
          }

          if (warning.code === 'BUSINESS_DAY_OF_REST'|| warning.code === 'SECOND_HALF_OF_CALENDAR_DAY_OF_REST' || warning.code === 'FIRST_HALF_OF_CALENDAR_DAY_OF_REST') {
              var msg = 'Not provided with a rest of 24 consecutive hours in the ';
              if(maxScheduleDaySettings['schedule_max_working_days_week_type'] === 'BUSINESS') {
                   msg += 'work ';
              }
              else {
                  msg += 'calendar ';
              }
              msg += 'week of ' + moment(warning['week_range'].start_date).format('MMM DD, YYYY') + ' - '
              + moment(warning['week_range'].end_date).format('MMM DD, YYYY');
              return msg;
          }

          if ([
              self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_HOURS_PER_WEEK.code,
              self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_DAYS_PER_WEEK.code,
              self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR.code,
              self.WARNING_SUB_CATEGORIES.MAX_WEEKLY_HOURS.code,
              self.WARNING_SUB_CATEGORIES.NO_EFFECTIVE_MINOR_TYPE.code,
              self.WARNING_SUB_CATEGORIES.MINOR_ROLLING_24_HOURS.code,
              self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_PER_WEEK.code,
              self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_BETWEEN_SHIFTS.code,
          ].includes(warning.code)) {
              return getWorkRestrictionWarningMsg(warning, 'day', !publishRestrictionsSettings.allow_schedule_publish_with_minor_violation);
          }

          if (['WORK_VISA_EMPLOYEE_EXCEEDS_HOURS_PER_WEEK', 'WORK_VISA_EMPLOYEE_EXCEEDS_DAYS_PER_WEEK', 'WORK_VISA_EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR', 'BEFORE_VISA_START_DATE', 'AFTER_VISA_END_DATE'].indexOf(warning.code) > -1) {
              return getWorkRestrictionWarningMsg(warning, 'day', !publishRestrictionsSettings.allow_schedule_publish_with_work_visa_violation);
          }

          if (warning.code === self.WARNING_SUB_CATEGORIES.OVER_WORK_LIMIT.code) {
              let message = $filter('translate')('48hr Work Limit') + '. ';
              if (!publishRestrictionsSettings.allow_schedule_publish_with_work_limit_violation) {
                  message += $filter('translate')('Reduce the employee’s hours per week to 48 or less');
              } else {
                  message += $filter('translate')('Scheduled over 48 hours per week');
              }
              return message;
          }

          if (warning.code === 'NEW_HIRED_EMPLOYEE') {
              return "FWW. New hires' first publish will not apply additional premium";
          }

          if (warning.code === 'REST_BETWEEN_DAYS') {
              return _filter('translate')('Rest between working days breach');
          }

          var shiftWarnings = getGFEWarningsTypeList('ROW');

          if (shiftWarnings.indexOf(warning.code) > -1) {
              return prepareGFEWarningText(warning);
          }

          if (warning.code === self.WARNING_SUB_CATEGORIES.OVER_DAYS_AND_HOURS_PER_WEEK.code) {
              return _filter('translate')(`Working Pattern. Scheduled over ${warning.hours_count} hours and ${warning.days_count} days per week.`);
          }
          if (warning.code === self.WARNING_SUB_CATEGORIES.OVER_DAYS_PER_WEEK.code) {
              return _filter('translate')(`Working Pattern. Scheduled over ${warning.days_count} days per week.`);
          }
          if (warning.code === self.WARNING_SUB_CATEGORIES.OVER_HOURS_PER_WEEK.code) {
              return _filter('translate')(`Working Pattern. Scheduled over ${warning.hours_count} hours per week.`);
          }
          if (warning.code === self.WARNING_SUB_CATEGORIES.WRONG_HOURS_FOR_DAY.code) {
              const day = moment(warning.date, 'MMMM DD, YYYY').format('dddd')
              return `${_filter('translate')(`Working Pattern. Scheduled over ${warning.hours_count} hour limit for`)} ${day}.`;
          }

          if (warning.code === self.WARNING_SUB_CATEGORIES.BELOW_DAYS_AND_HOURS_PER_WEEK.code) {
              return _filter('translate')(`Working Pattern. Scheduled below ${warning.hours_count} hours and ${warning.days_count} days per week.`);
          }
          if (warning.code === self.WARNING_SUB_CATEGORIES.BELOW_DAYS_PER_WEEK.code) {
              return _filter('translate')(`Working Pattern. Scheduled below ${warning.days_count} days per week.`);
          }
          if (warning.code === self.WARNING_SUB_CATEGORIES.BELOW_HOURS_PER_WEEK.code) {
              return _filter('translate')(`Working Pattern. Scheduled below ${warning.hours_count} hours per week.`);
          }
      };


        var getRowWarningShiftLevelText = function (warning, slot) {
            var scheduleSettings = scheduleDataServiceV2.getBrandScheduleSettings();
            var publishRestrictionsSettings = scheduleSettings['publish_restriction_settings'] || {};

            var shiftDay = slot ? slot['isExtendedFromPreviousDay'] ? slot['extendedDay'] : slot['day'] : null;
            var day = moment(shiftDay, "MMM DD, YYYY").format("dddd");

            if (warning.code === 'DAILY_OVERTIME') {
                return 'Scheduled over the daily overtime (' + OVERTIME_RATE_MAP[slot.costInfo.ot_daily_rate] + ')' + ' limit ' + (self.viewType === 'WEEKLY' ? ' on ' + day : '')
            }

            if (warning.code === 'DAILY_DOUBLE_OVERTIME') {
                return 'Scheduled over the daily overtime (2x) limit' + (self.viewType === 'WEEKLY' ? ' on ' + day : '');
            }

            if (warning.code === 'SPREAD_OF_HOURS') {
                return 'Shifts have spread of hours breach ' + (self.viewType === 'WEEKLY' ? ' on ' + day : '')
            }

            if (warning.code === 'OVERLAP') {
                return 'Shifts overlapping'
            }

            if (warning.code === 'CALL_INS') {
                var msg;
                if (!publishRestrictionsSettings.allow_schedule_publish_with_call_in_violation) {
                    msg = 'Reporting time. Increase the scheduled hours';
                } else {
                    msg = 'Shifts have reporting time breach';
                }
                return msg;
            }

            if (warning.code === 'UNSCHEDULED_BREAKS') {
                return 'Shifts missing scheduled breaks';
            }

            if (warning.code === 'UNDEFINED_JOB_TITLE_LEVEL') {
                return 'Station with skill level not assigned';
            }

            if (['AVAILABILITY', 'TIME_OFF', 'ABSENCE', 'SICKNESS', 'HOLIDAY'].indexOf(warning.code) > -1) {
                var overlapWithText = getOverlapWithText(warning.code);
                return 'Shifts overlap with their ' + overlapWithText;
            }

            if (warning.code === 'SKILL_LEVEL_4_OR_5') {
                return 'Station with skill level ' + warning.levels.join(',')
            }


            if (warning.code === 'CONSECUTIVE_OVERTIME' || warning.code === 'CONSECUTIVE_DOUBLE_OVERTIME' || warning.code == 'SEVENTH_CONSECUTIVE_OVERTIME') {
                return 'Scheduled to work 7 consecutive days';
            }

            if (warning.code === 'SPLIT_SHIFT_PREMIUMS') {
                return 'Shifts have split-shift breach'
            }

            if (warning.code === 'IN_SCHOOL_TIME') {
                var msg;
                if (!publishRestrictionsSettings.allow_schedule_publish_with_minor_violation) {
                    msg = 'Minor. schedule them outside school times'
                } else {
                    msg = 'Minor. Shifts overlap with school times'
                }
                return msg;
            }

            if ([
                self.WARNING_SUB_CATEGORIES.PROHIBITED_HOURS.code,
                self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_HOURS_PER_WEEK.code,
                self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_DAYS_PER_WEEK.code,
                self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR.code,
                self.WARNING_SUB_CATEGORIES.MAX_WEEKLY_HOURS.code,
                self.WARNING_SUB_CATEGORIES.MINOR_MAX_HOURS_PER_DAY.code,
                self.WARNING_SUB_CATEGORIES.MINOR_MAX_COMBINED_HOURS_PER_DAY.code,
                self.WARNING_SUB_CATEGORIES.NO_EFFECTIVE_MINOR_TYPE.code,
                self.WARNING_SUB_CATEGORIES.MINOR_ROLLING_24_HOURS.code,
                self.WARNING_SUB_CATEGORIES.MINOR_NO_EFFECTIVE_WORK_PERMIT.code,
                self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_BETWEEN_SHIFTS.code,
            ].includes(warning.code)) {
                return getWorkRestrictionWarningMsg(warning, day, !publishRestrictionsSettings.allow_schedule_publish_with_minor_violation);
            }

            var shiftWarnings = getGFEWarningsTypeList('SHIFT');
            if (shiftWarnings.indexOf(warning.code) > -1) {
                return prepareGFEWarningText(warning);
            }

            if (['DATE_TIME_CHANGE', 'LENGTH_INCREMENT', 'LENGTH_DECREMENT', 'RIGHT_TO_REST'].indexOf(warning.code) > -1) {
                var penaltyWarningText = preparePenaltyWarningText(warning, 'ROW', !publishRestrictionsSettings.allow_schedule_publish_with_right_to_rest_violation);
                return penaltyWarningText + (self.viewType === 'WEEKLY' ? ' for ' + day : '');
            }

            if (warning.code === 'PENDING_EMPLOYEE_CONSENT') {
                return 'FWW. Premium waiting employee’s consent';
            }

            if (warning.code === 'REST_BETWEEN_DAYS') {
                if (publishRestrictionsSettings.allow_schedule_publish_with_right_to_rest_compliance_violation) {
                    return _filter('translate')('Rest between working days breach') + (self.viewType === 'WEEKLY' ? ' ' + _filter('translate')('on') + ' ' + day : '');
                } else {
                    return _filter('translate')('Rest between working days') + '. ' +
                           _filter('translate')('Extend the period between shifts to at least') + ' ' +
                           _filter('number')(warning['restPeriod'] / 3600) + ' ' + _filter('translate')('hours')
                           + (self.viewType === 'WEEKLY' ? ' ' + _filter('translate')('on') + ' ' + day : '');
                }
            }

            if (warning.code === 'MARKED_DAY') {
                return warning.day + ' ' + _filter('translate')('is marked as')+ ' ' + warning.markAs + ' ' +_filter('translate')('for') + ' '+ warning.user.first_name + ' ' + warning.user.last_name;
            }

            if (warning.code === self.WARNING_SUB_CATEGORIES.SCHEDULED_ON_WRONG_DAY.code) {
                return `${_filter('translate')('Working Pattern. Should not be scheduled on')} ${day}.`;
            }
        };

        self.getUserWarningText = getRowWarningEmployeeLevelText;
        self.getShiftWarningText = getRowWarningShiftLevelText;

        var getOverlapWithText = function(code) {
            switch (code) {
                case "AVAILABILITY":
                    return 'availability';
                case "TIME_OFF":
                    return 'time off';
                case "ABSENCE":
                case "UNAUTHORIZED":
                    return 'absence';
                case "SICKNESS":
                    return 'sickness';
                case "HOLIDAY":
                    return 'holiday';
            }
        };

        self.prepareWarning = function ({count, user, shift_id, restricted, ...warning}) {
            const updatedWarning = {
                ...warning
            }

            if (user) {
                updatedWarning['employee'] = {
                    display_name: user.display_name,
                    id: user.id,
                    is_minor: user.is_minor
                };
            }

            if (shift_id) {
                const shift = scheduleDataServiceV2.flatData['shifts'][shift_id];

                updatedWarning['shift'] = shift && {
                    id: shift['id'],
                    start_time: shift['start_time'],
                    end_time: shift['end_time'],
                };
            }
            return updatedWarning;
        }

        self.getScheduleWarnings = function () {
            if (!self.warnings) {
                return null;
            }

            const warnings = Object.values(self.warnings['costs']);
            return warnings
                .filter(item => !!item.length)
                .flatMap((warnings) => {
                    return warnings.map(self.prepareWarning);
                });
        };

        self.checkForRowWarnings = function (schedule, row, sortBy, viewType) {
            var scheduleSettings = scheduleDataServiceV2.getBrandScheduleSettings();
            var publishRestrictionsSettings = scheduleSettings['publish_restriction_settings'] || {};

        	self.warnings['costs'] = self.warnings['costs'] || {};

	        row.warnings = [];
	        self.warnings['costs'][schedule.id + '_' + row.id] = [];
	        self.sortBy = sortBy;
	        self.viewType = viewType;
	        var shiftWarningsPerUser = {};
            var userIds = [];
            if (row.type === 'users') {
                userIds = [row.id];
            }

	        for (var l in row['lines']) {
		        var line = row['lines'][l];
		        for (var k in line['slots']) {
			        var slot = line['slots'][k];
			        if (slot.user_id) {
                        if (row.type !== 'users') {
                            if (userIds.indexOf(slot.user_id) === -1) {
                                userIds.push(slot.user_id);
                            }
                        }
                        shiftWarningsPerUser[slot.user_id] = shiftWarningsPerUser[slot.user_id] || [];
                        for (var w in self.warnings.shifts[slot.id]) {
                            var warningDetails = getRowWarningShiftLevelText(self.warnings.shifts[slot.id][w], slot);
                            shiftWarningsPerUser[slot.user_id].push({code: self.warnings.shifts[slot.id][w].code, message: warningDetails, shift_id: slot.id});
                        }
                    }
		        }
	        }

            if (self.viewType === 'WEEKLY') {
                var extendedShiftsForDay = scheduleDataServiceV2.getExtendedShiftsForWeek(schedule, row.id);

                for (var i in extendedShiftsForDay) {
                    var extendedSlot = extendedShiftsForDay[i];
                    if (extendedSlot.user_id) {
                        shiftWarningsPerUser[extendedSlot.user_id] = shiftWarningsPerUser[extendedSlot.user_id] || [];
                        for (var w in self.warnings.shifts[extendedSlot.id]) {
                            var extendedShiftWarning = self.warnings.shifts[extendedSlot.id][w];
                            var warningMsg = getRowWarningShiftLevelText(extendedShiftWarning, extendedSlot);
                            shiftWarningsPerUser[extendedSlot.user_id].push({code: extendedShiftWarning.code, message: warningMsg, shift_id: extendedSlot.id});
                        }
                    }
                }
            }

            Object.keys(shiftWarningsPerUser).forEach(function (k) {
                for (var i in shiftWarningsPerUser[k]) {
                    var warning = shiftWarningsPerUser[k][i];
                    var warningExistInRow = row.warnings.find(function (rowWarning) {
                        return (rowWarning.message).toLowerCase() === (warning.message).toLowerCase();
                    });
                    if (warningExistInRow) {
                        warningExistInRow.count++;
                    }
                    else {
                        var updateWarningObj = {
                            message: warning.message,
                            count: 1,
                            shift_id: warning.shift_id,
                            user: tsUsersService.users[k],
                            code: warning.code
                        };
                        if (warning.code === 'RIGHT_TO_REST') {
                            updateWarningObj['restricted'] = !publishRestrictionsSettings.allow_schedule_publish_with_right_to_rest_violation;
                        }

                        if (warning.code === 'REST_BETWEEN_DAYS') {
                            updateWarningObj['restricted'] = !publishRestrictionsSettings.allow_schedule_publish_with_right_to_rest_compliance_violation;
                        }

                        if (warning.code === 'CALL_INS') {
                            updateWarningObj['restricted'] = !publishRestrictionsSettings.allow_schedule_publish_with_call_in_violation;
                        }

                        if ([
                            self.WARNING_SUB_CATEGORIES.PROHIBITED_HOURS.code,
                            self.WARNING_SUB_CATEGORIES.IN_SCHOOL_TIME.code,
                            self.WARNING_SUB_CATEGORIES.MINOR_MAX_HOURS_PER_DAY.code,
                            self.WARNING_SUB_CATEGORIES.MINOR_MAX_COMBINED_HOURS_PER_DAY.code,
                            self.WARNING_SUB_CATEGORIES.NO_EFFECTIVE_MINOR_TYPE.code,
                            self.WARNING_SUB_CATEGORIES.MINOR_ROLLING_24_HOURS.code,
                            self.WARNING_SUB_CATEGORIES.MINOR_NO_EFFECTIVE_WORK_PERMIT.code,
                            self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_BETWEEN_SHIFTS.code,
                        ].includes(warning.code)) {
                            updateWarningObj['restricted'] = !publishRestrictionsSettings.allow_schedule_publish_with_minor_violation;
                        }

                        row.warnings.push(updateWarningObj);
                    }
                }
            });

            for (var id in userIds) {
                var userWarnings = self.warnings.users[userIds[id]];
                for (var u in userWarnings) {
                    var userWarning = userWarnings[u];
                    var updatedUserWarning = {
                        message: getRowWarningEmployeeLevelText(userWarning, userIds[id]),
                        count: 1,
                        user: tsUsersService.users[userIds[id]],
                        code: userWarning.code
                    };

                    if ([
                        self.WARNING_SUB_CATEGORIES.MAX_GUEST_WEEKLY_HOURS.code,
                        self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_HOURS_PER_WEEK.code,
                        self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_DAYS_PER_WEEK.code,
                        self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR.code,
                        self.WARNING_SUB_CATEGORIES.MAX_WEEKLY_HOURS.code,
                        self.WARNING_SUB_CATEGORIES.MINOR_ROLLING_24_HOURS.code,
                        self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_PER_WEEK.code,
                        self.WARNING_SUB_CATEGORIES.MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_BETWEEN_SHIFTS.code,
                    ].includes(userWarning.code)) {
                        updatedUserWarning['restricted'] = !publishRestrictionsSettings.allow_schedule_publish_with_minor_violation;
                    }

                    if (['WORK_VISA_EMPLOYEE_EXCEEDS_HOURS_PER_WEEK', 'WORK_VISA_EMPLOYEE_EXCEEDS_DAYS_PER_WEEK', 'WORK_VISA_EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR','BEFORE_VISA_START_DATE', 'AFTER_VISA_END_DATE',].indexOf(userWarning.code) > -1) {
                        updatedUserWarning['restricted'] = !publishRestrictionsSettings.allow_schedule_publish_with_work_visa_violation;
                    }

                    if (userWarning.code === 'BELOW_MIN_WEEKLY_HOURS') {
                        updatedUserWarning['restricted'] = !publishRestrictionsSettings.allow_schedule_publish_with_min_weekly_scheduled_hours_violation;
                    }

                    if (userWarning.code === self.WARNING_SUB_CATEGORIES.OVER_WORK_LIMIT.code){
                        updatedUserWarning['restricted'] = !publishRestrictionsSettings.allow_schedule_publish_with_work_limit_violation;
                    }

                    row.warnings.push(updatedUserWarning);
                }
            }

            row.hasRestrictedWarnings = checkIfRowHasRestrictedWarnings(row.warnings);


	        self.warnings['costs'][schedule.id + '_' + row.id] = row.warnings;
        };

        var checkIfRowHasRestrictedWarnings = function(warnings) {
            return !!(warnings.find(function (warning) {
                return warning.restricted;
            }))
        };

        self.setPenaltiesList = function (penaltiesList) {
            var newPenalties = FairSchedulingService.checkUpdatedPremiums(penaltiesWarnings, penaltiesList);

            if (newPenalties.length) {
                for (var i in newPenalties) {
                    var penaltyDetails = newPenalties[i];
                    var penaltyMessage = preparePenaltyWarningText(penaltyDetails, 'USER');
                    var userName = tsUsersService.users[penaltyDetails.user_id] && (tsUsersService.users[penaltyDetails.user_id].first_name + ' ' +  tsUsersService.users[penaltyDetails.user_id].last_name);
                    var message = userName + ' ' + penaltyMessage;

                    if (penaltyDetails.type !== 'RIGHT_TO_REST') {
                        message += ' on ' + penaltyDetails.date;
                        if (penaltyDetails.isRequiredEmployeeConsent) {
                            message += ' that requires employee’s consent';
                        }
                    }

                    HNotifications.show({
                        desc: _filter("translate")(message),
                        icon: "fa-warning",
                        type: "danger",
                        timeout: 8000
                    });
                }
            }

            penaltiesWarnings = penaltiesList;
        };

        self.setRestBetweenDayWarnings = function (restBetweenDaysWarningsList) {
            restBetweenDaysWarnings = restBetweenDaysWarningsList;
        }

        self.setGFEUsersWarnings = function (gfeUsersWarnings) {
            gfeWarnings = gfeUsersWarnings;
        };

        self.getGFEUsersWarnings = function () {
            return gfeWarnings || [];
        };

        self.getPenaltiesWarnings = function () {
            return penaltiesWarnings;
        };

        self.checkIfUserHasShifts = function (warningCode, userId, scheduleDailyViewDate, shiftIdsWithWarnings) {
            var userIds = scheduleDataServiceV2.flatData['days'][scheduleDailyViewDate] && scheduleDataServiceV2.flatData['days'][scheduleDailyViewDate]['user_ids'];
            var isUserAddedOnSchedule = userIds && userIds.indexOf(userId) > -1;

            if (warningCode === self.WARNING_SUB_CATEGORIES.NOT_SCHEDULED.code || warningCode === self.WARNING_SUB_CATEGORIES.NYC_NOT_SCHEDULED.code) {
                return true;
            }

            if (warningCode === self.WARNING_CATEGORIES.DEACTIVATED.code ||
                warningCode === self.WARNING_CATEGORIES.BUSINESS_DAY_OF_REST.code ||
                (self.WARNING_SUB_CATEGORIES[warningCode] && self.WARNING_SUB_CATEGORIES[warningCode].warningLevel === self.WARNING_LEVELS.EMPLOYEE_LEVEL)) {
                return isUserAddedOnSchedule;
            }

            if (isUserAddedOnSchedule) {
                var shifts = scheduleDataServiceV2.flatData['users'][userId]['shift_ids'];

                for (var i in shifts) {
                    var shiftId = shifts[i];
                    var shift = scheduleDataServiceV2.flatData['shifts'][shiftId];

                    if (
                        shift &&
                        (!shiftIdsWithWarnings || shiftIdsWithWarnings.indexOf(shift.id) > -1) &&
                        shift.day === scheduleDailyViewDate
                    ) {
                        return true;
                    }
                }
            }

            return false;
        };

        self.reset = function () {
            penaltiesWarnings = null;
            gfeWarnings = null;
            self.warnings = undefined;
            self.scheduleWarnings = undefined;
            restBetweenDaysWarnings = null;
        }
    };

    ServiceController.$inject = ['$filter', 'ScheduleDataServiceV2', 'ScheduleCostsServiceV2', 'TSUsersService', 'minorSchedulingService', 'fairSchedulingService', 'justCauseService', 'philippinesMinWeeklyHoursService', 'scheduleDateUtilsService', 'workVisasService', 'workRestrictionsService', 'useWorkingPatternsWarningsFactory'];

    function ServiceController($filter, ScheduleDataServiceV2, ScheduleCostsServiceV2, TSUsersService, minorSchedulingService, fairSchedulingService, justCauseService, philippinesMinWeeklyHoursService, scheduleDateUtilsService, workVisasService, workRestrictionsService, useWorkingPatternsWarningsFactory) {
        scheduleDataServiceV2 = ScheduleDataServiceV2;
        WorkVisasService = workVisasService;
        scheduleCostsServiceV2 = ScheduleCostsServiceV2;
        tsUsersService = TSUsersService;
        MinorSchedulingService = minorSchedulingService;
        WorkRestrictionsService = workRestrictionsService;
        FairSchedulingService = fairSchedulingService;
        JustCauseService = justCauseService;
        PhilippinesMinWeeklyHoursService = philippinesMinWeeklyHoursService;
        _filter = $filter;
        _scheduleDateUtilsService = scheduleDateUtilsService;
        workingPatternsWarningsFactory = useWorkingPatternsWarningsFactory();

        return new ScheduleWarningServiceV2();
    }

    app.service("ScheduleWarningServiceV2", ServiceController);

})();
